  const translations = {
  'es': {
    selectAll: 'Por favor, seleccione todas las opciones para obtener una guía personalizada.',
    personalizedGuide: 'Tu Guía Personalizada de Estilo de Sombreros',
    basedOn: 'Basado en tu',
    faceShape: 'forma de cara',
    height: 'altura',
    andPreference: 'y preferencia por',
    styles: 'estilos',
    guidance: "aquí está tu guía personalizada de sombreros:",
    readyToFind: "¿Listo para encontrar tu sombrero perfecto?",
    startingPoint: "¡Tus recomendaciones personalizadas son solo el comienzo!",
    filterDescription: "Dirígete a nuestra colección curada y usa nuestros filtros inteligentes para encontrar sombreros que combinen con la forma de tu cara, complementen tu altura y conecten con tu estilo. Nuestros filtros facilitan el descubrimiento de sombreros que no solo favorecen tus rasgos únicos, sino que también permiten que tu personalidad brille.",
    fromClassic: "¡Desde diseños clásicos hasta estilos modernos, convirtamos esas recomendaciones en tu nuevo accesorio favorito!",
    exploreCollection: "EXPLORA NUESTRA COLECCIÓN",
    viewDetails: "Ver Detalles",
    from: "Desde EUR"
  },
  'en': {
    selectAll: 'Please select all options to get personalized guidance.',
    personalizedGuide: 'Your Personalized Hat Style Guide',
    basedOn: 'Based on your',
    faceShape: 'face shape',
    height: 'height',
    andPreference: 'and preference for',
    styles: 'styles',
    guidance: "here's your personalized hat guidance:",
    readyToFind: "Ready to Find Your Perfect Hat?",
    startingPoint: "Your personalized recommendations are just the beginning!",
    filterDescription: "Head to our curated collection and use our smart filters to find hats that match your face shape, complement your height, and resonate with your style. Our filters make it easy to discover hats that not only flatter your unique features but let your personality shine through.",
    fromClassic: "From classic designs to modern styles, let's turn these recommendations into your new favorite accessory!",
    exploreCollection: "EXPLORE OUR COLLECTION",
    viewDetails: "View Details",
    from: "From EUR",
    selectFaceShape: "Select Face Shape",
    selectHeight: "Select Height",
    selectStyle: "Select Style",
    shortHeight: "Short (Under 5'8\")",
    averageHeight: "Average (5'8\" - 6')",
    tallHeight: "Tall (Over 6')",
    classicStyle: "Classic",
    westernStyle: "Western",
    vintageStyle: "Vintage",
    modernStyle: "Modern",
    craftButton: "CRAFT MY HAT SUGGESTION",
    shopCollection: "SHOP THE COLLECTION"
  },    
  'fr': {
    selectAll: 'Veuillez sélectionner toutes les options pour obtenir des conseils personnalisés.',
    personalizedGuide: 'Votre Guide Personnalisé de Style de Chapeau',
    basedOn: 'Basé sur votre',
    faceShape: 'forme de visage',
    height: 'taille',
    andPreference: 'et préférence pour les',
    styles: 'styles',
    guidance: "voici vos conseils personnalisés pour votre chapeau :",
    readyToFind: "Prêt à trouver votre chapeau parfait ?",
    startingPoint: "Vos recommandations personnalisées ne sont que le début !",
    filterDescription: "Dirigez-vous vers notre collection sélectionnée et utilisez nos filtres intelligents pour trouver des chapeaux qui correspondent à la forme de votre visage, complètent votre taille et résonnent avec votre style. Nos filtres facilitent la découverte de chapeaux qui non seulement mettent en valeur vos traits uniques mais laissent aussi transparaître votre personnalité.",
    fromClassic: "Des designs classiques aux styles modernes, transformons ces recommandations en votre nouvel accessoire préféré !",
    exploreCollection: "EXPLORER NOTRE COLLECTION",
    viewDetails: "Voir les Détails",
    from: "À partir de EUR"
  },
  'de': {
    selectAll: 'Bitte wählen Sie alle Optionen aus, um eine personalisierte Beratung zu erhalten.',
    personalizedGuide: 'Ihr persönlicher Hut-Stilführer',
    basedOn: 'Basierend auf Ihrer',
    faceShape: 'Gesichtsform',
    height: 'Größe',
    andPreference: 'und Vorliebe für',
    styles: 'Stile',
    guidance: "hier ist Ihre personalisierte Hutberatung:",
    readyToFind: "Bereit, Ihren perfekten Hut zu finden?",
    startingPoint: "Ihre personalisierten Empfehlungen sind erst der Anfang!",
    filterDescription: "Gehen Sie zu unserer kuratierten Kollektion und nutzen Sie unsere intelligenten Filter, um Hüte zu finden, die zu Ihrer Gesichtsform passen, Ihre Größe ergänzen und Ihrem Stil entsprechen. Unsere Filter machen es einfach, Hüte zu entdecken, die nicht nur Ihre einzigartigen Merkmale schmeicheln, sondern auch Ihre Persönlichkeit zum Ausdruck bringen.",
    fromClassic: "Von klassischen Designs bis hin zu modernen Stilen – lassen Sie uns diese Empfehlungen in Ihr neues Lieblingsaccessoire verwandeln!",
    exploreCollection: "KOLLEKTION ENTDECKEN",
    viewDetails: "Details Anzeigen",
    from: "Ab EUR"
  },
  'it': {
    selectAll: 'Seleziona tutte le opzioni per ricevere una guida personalizzata.',
    personalizedGuide: 'La Tua Guida Personalizzata allo Stile del Cappello',
    basedOn: 'Basato sulla tua',
    faceShape: 'forma del viso',
    height: 'altezza',
    andPreference: 'e preferenza per gli',
    styles: 'stili',
    guidance: "ecco la tua guida personalizzata per il cappello:",
    readyToFind: "Pronto a trovare il tuo cappello perfetto?",
    startingPoint: "Le tue raccomandazioni personalizzate sono solo l'inizio!",
    filterDescription: "Vai alla nostra collezione curata e usa i nostri filtri intelligenti per trovare cappelli che si abbinano alla forma del tuo viso, completano la tua altezza e rispecchiano il tuo stile. I nostri filtri rendono facile scoprire cappelli che non solo valorizzano i tuoi tratti unici ma lasciano anche trasparire la tua personalità.",
    fromClassic: "Dai design classici agli stili moderni, trasformiamo queste raccomandazioni nel tuo nuovo accessorio preferito!",
    exploreCollection: "ESPLORA LA NOSTRA COLLEZIONE",
    viewDetails: "Visualizza Dettagli",
    from: "Da EUR"
  },
  'pt': {
    selectAll: 'Por favor, selecione todas as opções para obter orientação personalizada.',
    personalizedGuide: 'Seu Guia Personalizado de Estilo de Chapéu',
    basedOn: 'Com base na sua',
    faceShape: 'forma do rosto',
    height: 'altura',
    andPreference: 'e preferência por',
    styles: 'estilos',
    guidance: "aqui está a sua orientação personalizada para chapéus:",
    readyToFind: "Pronto para encontrar o seu chapéu perfeito?",
    startingPoint: "Suas recomendações personalizadas são apenas o começo!",
    filterDescription: "Vá até nossa coleção curada e use nossos filtros inteligentes para encontrar chapéus que combinam com a forma do seu rosto, complementam sua altura e ressoam com seu estilo. Nossos filtros facilitam a descoberta de chapéus que não só valorizam suas características únicas, mas também deixam sua personalidade brilhar.",
    fromClassic: "De designs clássicos a estilos modernos, vamos transformar essas recomendações no seu novo acessório favorito!",
    exploreCollection: "EXPLORE NOSSA COLEÇÃO",
    viewDetails: "Ver Detalhes",
    from: "A partir de EUR"
  },
  'nl': {
    selectAll: 'Selecteer alle opties om gepersonaliseerde begeleiding te krijgen.',
    personalizedGuide: 'Uw Gepersonaliseerde Hoedenstijlgids',
    basedOn: 'Gebaseerd op uw',
    faceShape: 'gezichtsvorm',
    height: 'lengte',
    andPreference: 'en voorkeur voor',
    styles: 'stijlen',
    guidance: "hier is uw gepersonaliseerde hoedenbegeleiding:",
    readyToFind: "Klaar om uw perfecte hoed te vinden?",
    startingPoint: "Uw gepersonaliseerde aanbevelingen zijn nog maar het begin!",
    filterDescription: "Ga naar onze gecureerde collectie en gebruik onze slimme filters om hoeden te vinden die passen bij uw gezichtsvorm, uw lengte complementeren en aansluiten bij uw stijl. Onze filters maken het gemakkelijk om hoeden te ontdekken die niet alleen uw unieke kenmerken flatteren, maar ook uw persoonlijkheid laten schitteren.",
    fromClassic: "Van klassieke ontwerpen tot moderne stijlen, laten we deze aanbevelingen omzetten in uw nieuwe favoriete accessoire!",
    exploreCollection: "ONTDEK ONZE COLLECTIE",
    viewDetails: "Details Bekijken",
    from: "Vanaf EUR"
  },
  'sv': {
    selectAll: 'Vänligen välj alla alternativ för att få personlig vägledning.',
    personalizedGuide: 'Din Personliga Hattstilguide',
    basedOn: 'Baserat på din',
    faceShape: 'ansiktsform',
    height: 'längd',
    andPreference: 'och preferens för',
    styles: 'stilar',
    guidance: "här är din personliga hattvägledning:",
    readyToFind: "Redo att hitta din perfekta hatt?",
    startingPoint: "Dina personliga rekommendationer är bara början!",
    filterDescription: "Gå till vår kuraterade kollektion och använd våra smarta filter för att hitta hattar som matchar din ansiktsform, kompletterar din längd och resonerar med din stil. Våra filter gör det enkelt att upptäcka hattar som inte bara framhäver dina unika drag utan också låter din personlighet lysa igenom.",
    fromClassic: "Från klassiska designer till moderna stilar, låt oss förvandla dessa rekommendationer till ditt nya favoritaccessoar!",
    exploreCollection: "UTFORSKA VÅR KOLLEKTION",
    viewDetails: "Visa Detaljer",
    from: "Från EUR"
  },
  'fi': {
    selectAll: 'Valitse kaikki vaihtoehdot saadaksesi henkilökohtaista ohjausta.',
    personalizedGuide: 'Henkilökohtainen Hattutyylioppaasi',
    basedOn: 'Perustuen sinun',
    faceShape: 'kasvojen muotoon',
    height: 'pituuteen',
    andPreference: 'ja mieltymykseen',
    styles: 'tyyleistä',
    guidance: "tässä on henkilökohtainen hattuohjauksesi:",
    readyToFind: "Valmis löytämään täydellisen hattusi?",
    startingPoint: "Henkilökohtaiset suosituksesi ovat vasta alkua!",
    filterDescription: "Siirry kuratoituun kokoelmaamme ja käytä älykkäitä suodattimiamme löytääksesi hattuja, jotka sopivat kasvojesi muotoon, täydentävät pituuttasi ja resonoivat tyylisi kanssa. Suodattimemme tekevät helpoksi löytää hattuja, jotka eivät ainoastaan imartele ainutlaatuisia piirteitäsi, vaan antavat myös persoonallisuutesi loistaa.",
    fromClassic: "Klassisista designeista moderneihin tyyleihin, muutetaan nämä suositukset uudeksi suosikkiasusteeksesi!",
    exploreCollection: "TUTUSTU KOKOELMAAMME",
    viewDetails: "Katso Tiedot",
    from: "Alkaen EUR"
  },
  'ar': {
    selectAll: 'يرجى تحديد جميع الخيارات للحصول على إرشادات شخصية.',
    personalizedGuide: 'دليلك الشخصي لأسلوب القبعات',
    basedOn: 'بناءً على',
    faceShape: 'شكل وجهك',
    height: 'طولك',
    andPreference: 'وتفضيلك لـ',
    styles: 'الأنماط',
    guidance: "إليك إرشاداتك الشخصية للقبعات:",
    readyToFind: "هل أنت مستعد للعثور على قبعتك المثالية؟",
    startingPoint: "توصياتك الشخصية هي مجرد البداية!",
    filterDescription: "توجه إلى مجموعتنا المنتقاة واستخدم مرشحاتنا الذكية للعثور على القبعات التي تتناسب مع شكل وجهك وتكمل طولك وتتناغم مع أسلوبك. تجعل مرشحاتنا من السهل اكتشاف القبعات التي لا تبرز ملامحك الفريدة فحسب، بل تدع شخصيتك تتألق أيضاً.",
    fromClassic: "من التصاميم الكلاسيكية إلى الأنماط العصرية، دعنا نحول هذه التوصيات إلى إكسسوارك المفضل الجديد!",
    exploreCollection: "استكشف مجموعتنا",
    viewDetails: "عرض التفاصيل",
    from: "من EUR"
  },
  'zh': {
    selectAll: '请选择所有选项以获取个性化指导。',
    personalizedGuide: '您的个性化帽子风格指南',
    basedOn: '基于您的',
    faceShape: '脸型',
    height: '身高',
    andPreference: '和对',
    styles: '风格的偏好',
    guidance: "这是您的个性化帽子指导：",
    readyToFind: "准备好找到您的完美帽子了吗？",
    startingPoint: "您的个性化推荐仅仅是开始！",
    filterDescription: "前往我们精心策划的系列，使用我们的智能筛选器找到适合您脸型、衬托您身高并与您的风格相呼应的帽子。我们的筛选器让您轻松发现不仅能突出您独特特征，还能让您的个性闪耀的帽子。",
    fromClassic: "从经典设计到现代风格，让我们将这些推荐转变为您的新宠饰品！",
    exploreCollection: "探索我们的系列",
    viewDetails: "查看详情",
    from: "起价 EUR"
  },
  'ja': {
    selectAll: 'パーソナライズされたガイダンスを受けるには、すべてのオプションを選択してください。',
    personalizedGuide: 'あなたのパーソナライズ帽子スタイルガイド',
    basedOn: 'あなたの',
    faceShape: '顔の形',
    height: '身長',
    andPreference: 'と好みの',
    styles: 'スタイル',
    guidance: "に基づいたパーソナライズ帽子ガイダンスです：",
    readyToFind: "理想の帽子を見つける準備はできましたか？",
    startingPoint: "パーソナライズされたおすすめはほんの始まりです！",
    filterDescription: "当社が厳選したコレクションをご覧いただき、スマートフィルターを使用して、あなたの顔の形に合い、身長を引き立て、スタイルに共鳴する帽子を見つけてください。フィルターを使用すれば、あなたの独特な特徴を引き立てるだけでなく、個性も輝かせる帽子を簡単に見つけることができます。",
    fromClassic: "クラシックなデザインからモダンなスタイルまで、これらのおすすめをあなたの新しいお気に入りのアクセサリーに変えましょう！",
    exploreCollection: "コレクションを見る",
    viewDetails: "詳細を見る",
    from: "EUR から"
  },
  'ko': {
    selectAll: '맞춤형 가이드를 받으려면 모든 옵션을 선택해 주세요.',
    personalizedGuide: '맞춤형 모자 스타일 가이드',
    basedOn: '귀하의',
    faceShape: '얼굴형',
    height: '키',
    andPreference: '그리고',
    styles: '스타일 선호도',
    guidance: "에 기반한 맞춤형 모자 가이드입니다:",
    readyToFind: "완벽한 모자를 찾을 준비가 되셨나요?",
    startingPoint: "맞춤형 추천은 시작일 뿐입니다!",
    filterDescription: "저희가 큐레이팅한 컬렉션에서 스마트 필터를 사용하여 얼굴형에 맞고, 키를 보완하며, 스타일과 어울리는 모자를 찾아보세요. 필터를 통해 귀하의 독특한 특징을 돋보이게 하고 개성을 표현할 수 있는 모자를 쉽게 발견할 수 있습니다.",
    fromClassic: "클래식한 디자인부터 모던한 스타일까지, 이러한 추천을 새로운 최애 액세서리로 만들어보세요!",
    exploreCollection: "컬렉션 둘러보기",
    viewDetails: "상세 보기",
    from: "EUR부터"
  },
  'no': {
    selectAll: 'Vennligst velg alle alternativer for å få personlig veiledning.',
    personalizedGuide: 'Din Personlige Hattstilguide',
    basedOn: 'Basert på din',
    faceShape: 'ansiktsform',
    height: 'høyde',
    andPreference: 'og preferanse for',
    styles: 'stiler',
    guidance: "her er din personlige hattveiledning:",
    readyToFind: "Klar til å finne din perfekte hatt?",
    startingPoint: "Dine personlige anbefalinger er bare begynnelsen!",
    filterDescription: "Gå til vår kuraterte kolleksjon og bruk våre smarte filtre for å finne hatter som matcher din ansiktsform, komplementerer din høyde og resonerer med din stil. Våre filtre gjør det enkelt å oppdage hatter som ikke bare fremhever dine unike trekk, men også lar din personlighet skinne gjennom.",
    fromClassic: "Fra klassiske design til moderne stiler, la oss gjøre disse anbefalingene til ditt nye favoritt-tilbehør!",
    exploreCollection: "UTFORSK VÅR KOLLEKSJON",
    viewDetails: "Se Detaljer",
    from: "Fra EUR"
  },
  'pl': {
    selectAll: 'Proszę wybrać wszystkie opcje, aby otrzymać spersonalizowane wskazówki.',
    personalizedGuide: 'Twój Spersonalizowany Przewodnik po Stylach Kapeluszy',
    basedOn: 'Na podstawie Twojego',
    faceShape: 'kształtu twarzy',
    height: 'wzrostu',
    andPreference: 'i preferencji dotyczących',
    styles: 'stylów',
    guidance: "oto Twoje spersonalizowane wskazówki dotyczące kapeluszy:",
    readyToFind: "Gotowy znaleźć swój idealny kapelusz?",
    startingPoint: "Twoje spersonalizowane rekomendacje to dopiero początek!",
    filterDescription: "Przejdź do naszej wyselekcjonowanej kolekcji i użyj naszych inteligentnych filtrów, aby znaleźć kapelusze pasujące do kształtu Twojej twarzy, podkreślające Twój wzrost i odpowiadające Twojemu stylowi. Nasze filtry ułatwiają odkrywanie kapeluszy, które nie tylko pochlebiają Twoim unikalnym cechom, ale również pozwalają zabłysnąć Twojej osobowości.",
    fromClassic: "Od klasycznych wzorów po nowoczesne style, zamieńmy te rekomendacje w Twój nowy ulubiony dodatek!",
    exploreCollection: "ODKRYJ NASZĄ KOLEKCJĘ",
    viewDetails: "Zobacz Szczegóły",
    from: "Od EUR"
  },
  'ru': {
    selectAll: 'Пожалуйста, выберите все параметры, чтобы получить персонализированные рекомендации.',
    personalizedGuide: 'Ваш Персонализированный Гид по Стилю Шляп',
    basedOn: 'На основе вашей',
    faceShape: 'формы лица',
    height: 'роста',
    andPreference: 'и предпочтений в',
    styles: 'стилях',
    guidance: "вот ваши персонализированные рекомендации по шляпам:",
    readyToFind: "Готовы найти свою идеальную шляпу?",
    startingPoint: "Ваши персонализированные рекомендации - это только начало!",
    filterDescription: "Перейдите к нашей подобранной коллекции и используйте наши умные фильтры, чтобы найти шляпы, которые подходят к форме вашего лица, дополняют ваш рост и соответствуют вашему стилю. Наши фильтры помогут легко найти шляпы, которые не только подчеркнут ваши уникальные черты, но и позволят вашей индивидуальности сиять.",
    fromClassic: "От классических дизайнов до современных стилей, давайте превратим эти рекомендации в ваш новый любимый аксессуар!",
    exploreCollection: "ИССЛЕДУЙТЕ НАШУ КОЛЛЕКЦИЮ",
    viewDetails: "Посмотреть Детали",
    from: "От EUR"
  }
};

function detectShopifyLanguage() {
  try {
    if (window.Shopify?.locale) return window.Shopify.locale;
    
    const htmlLang = document.documentElement.lang;
    if (htmlLang) return htmlLang;
    
    const langMeta = document.querySelector('meta[property="og:locale"]');
    if (langMeta) return langMeta.content;
  } catch (e) {
    console.warn('Language detection failed:', e);
  }
  
  return 'en';
}

function getTranslation(key) {
  const lang = detectShopifyLanguage().toLowerCase().split('-')[0];
  return translations[lang]?.[key] || translations['en'][key];
}

function getLocalizedUrl(url) {
  try {
    const locale = detectShopifyLanguage().toLowerCase();
    
    // If locale is English or undefined, return original URL
    if (!locale || locale === 'en') {
      return url;
    }
    
    // Split URL into parts
    const urlParts = url.split('www.agnoulitahats.com');
    if (urlParts.length !== 2) return url;
    
    // Add locale prefix
    return `${urlParts[0]}www.agnoulitahats.com/${locale}${urlParts[1]}`;
  } catch (e) {
    console.warn('Error generating localized URL:', e);
    return url;
  }
}

function generateProductCards(faceShape, height, style) {
  const combinations = {
"Oval,Short,Classic": [
{
name: "The Diplomat",
url: "https://www.agnoulitahats.com/products/mens-teardrop-fedora-diplomat-dark-grey",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Dark-Slate-Grey-Mens-Teardrop-Fedora-in-Smooth-Fur-Felt-The-Diplomat-Agnoulita-Hats-1_102c2463-8ff0-4515-b74e-5247fa777bc2.webp?v=1726607265",
price: 215,
subtitle: "Classic Teardrop Crown Fedora",
overview: "A timeless teardrop crown fedora in dark grey, perfect for the sophisticated gentleman with a shorter stature and oval face shape."
},
{
name: "The Tobin",
url: "https://www.agnoulitahats.com/products/cream-fedora-hat-tobin",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Handcrafted-Cream-Fedora-Hat-in-Premium-Fur-Felt-The-Tobin-Agnoulita-Hats-1_e3482030-77f3-4a60-8502-fa6485f806eb.png?v=1726434856",
price: 215,
subtitle: "Elegant Cream Fedora",
overview: "A handcrafted cream fedora with a classic single-crease crown, ideal for shorter individuals with oval face shapes seeking a timeless look."
},
{
name: "The Cooper",
url: "https://www.agnoulitahats.com/products/black-low-crown-fedora-hat-cooper",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Low-Crown-Fedora-Hat-in-Black-Fur-Felt-The-Cooper-Agnoulita-Hats-1_3b92a6c0-3906-47dc-87dd-e49867bedb2e.webp?v=1726002542",
price: 215,
subtitle: "Sleek Low Crown Fedora",
overview: "A black low crown fedora that complements shorter statures and oval face shapes, offering a classic yet modern silhouette."
}
],
"Oval,Short,Western": [
{
name: "The Bison",
url: "https://www.agnoulitahats.com/products/western-fedora-premium-fur-felt-bison",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-Short-Brim-Western-Fedora-in-Durable-Fur-Felt-The-Bison-Agnoulita-Hats-1_2c375126-e436-42a2-b94d-5f598dd2f564.png?v=1726434621",
price: 215,
subtitle: "Short Brim Western Fedora",
overview: "A brown short brim western fedora that's perfect for those with oval faces and shorter statures, blending classic western style with a modern fit."
},
{
name: "The Talisman",
url: "https://www.agnoulitahats.com/products/western-country-hat-talisman-desert-taupe-brown",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Rugged-Western-Country-Hat-for-Outdoor-Adventures-The-Talisman-Agnoulita-Hats-1.webp?v=1727384897",
price: 215,
subtitle: "Rugged Western Country Hat",
overview: "A versatile western country hat with a telescope crown, ideal for shorter individuals with oval faces looking for an authentic western look."
},
{
name: "The Voodoo",
url: "https://www.agnoulitahats.com/products/dark-grey-telescope-crown-country-hat-voodoo",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Dark-Grey-Telescope-Crown-Country-Style-Fur-Felt-Hat-The-Voodoo-Agnoulita-Hats-1.webp?v=1726695032",
price: 215,
subtitle: "Telescope Crown Country Hat",
overview: "A dark grey telescope crown country hat that complements oval face shapes and shorter statures, offering a blend of western charm and modern style."
}
],
"Oval,Short,Vintage": [
{
name: "The Phaeton",
url: "https://www.agnoulitahats.com/products/vintage-homburg-hat-for-men-phaeton",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Light-Camel-Vintage-Style-Homburg-Hat-for-Men-The-Phaeton-Agnoulita-Hats-1_41305c22-e554-45f0-861a-28d87989d9f0.webp?v=1725829799",
price: 215,
subtitle: "Retro Homburg Hat",
overview: "A vintage-inspired homburg hat that perfectly suits oval face shapes and shorter statures, bringing a touch of classic elegance to any outfit."
},
{
name: "The Gin Joint",
url: "https://www.agnoulitahats.com/products/bogart-fedora-hat-film-noir-style-gin-joint",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Stylish-Bogart-Fedora-Hat-in-Grey-Fur-Felt-The-Gin-Joint-Agnoulita-Hats-1_4e8597fb-e546-4942-95e3-e40719b12a2d.webp?v=1726262096",
price: 215,
subtitle: "Bogart-Style Fedora",
overview: "A grey Bogart-style fedora that captures the essence of vintage Hollywood, ideal for those with oval faces and shorter statures."
},
{
name: "The Silkstone",
url: "https://www.agnoulitahats.com/products/grey-wide-brim-center-dent-fedora-silkstone",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Grey-Wide-Brim-Center-Dent-Fedora-in-High-quality-Fur-Felt-The-Silkstone-Agnoulita-Hats-1_eb16a689-8b8a-4551-99aa-845e6a2400d6.webp?v=1726262272",
price: 215,
subtitle: "Vintage-Inspired Wide Brim Fedora",
overview: "A grey wide brim fedora with a center dent crown, perfect for shorter individuals with oval faces looking to channel a classic 1940s look."
}
],
"Oval,Short,Modern": [
{
name: "The Colombo",
url: "https://www.agnoulitahats.com/products/small-brim-trilby-fedora-hat-colombo",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Burnt-Orange-Small-Brim-Trilby-Fedora-Hat-in-Stylish-Fur-Felt-The-Colombo-Agnoulita-Hats-1_610d651f-449f-4ef0-9ca7-490029432c41.webp?v=1726003132",
price: 215,
subtitle: "Modern Small Brim Trilby",
overview: "A burnt orange small brim trilby that offers a contemporary twist on classic style, perfect for those with oval faces and shorter statures."
},
{
name: "The Clubber",
url: "https://www.agnoulitahats.com/products/light-blue-medium-crown-fedora-clubber",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Light-Blue-Fur-Felt-Fedora-Hat-With-A-Medium-Crown-The-Clubber-Agnoulita-Hats-1.webp?v=1726780208",
price: 215,
subtitle: "Modern Medium Crown Fedora",
overview: "A light blue fedora with a medium crown, offering a fresh and modern look that complements oval face shapes and shorter statures."
},
{
name: "The Equinox",
url: "https://www.agnoulitahats.com/products/fuchsia-fedora-hat-equinox",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Stylish-Fuchsia-Fedora-Hat-with-Custom-Fit-The-Equinox-Agnoulita-Hats-1_1c4ab564-3455-4490-b0f9-b5ab7aac574b.webp?v=1726782429",
price: 215,
subtitle: "Bold Fuchsia Fedora",
overview: "A stylish fuchsia fedora that makes a modern statement while flattering oval face shapes and shorter statures with its well-proportioned design."
}
],
"Oval,Average,Classic": [
{
name: "The Pandamator",
url: "https://www.agnoulitahats.com/products/camel-fedora-for-men-pandamator",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Classic-Camel-Fedora-for-Men-in-Premium-Beaver-Fur-Felt-The-Pandamator-Agnoulita-Hats-1.webp?v=1725916217",
price: 315,
subtitle: "Classic Camel Beaver Fur Fedora",
overview: "A timeless camel fedora crafted from premium beaver fur felt, perfect for the average-height gentleman with an oval face seeking a sophisticated look."
},
{
name: "The Acropol",
url: "https://www.agnoulitahats.com/products/dark-brown-fedora-hat-acropol",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Dark-Brown-Fedora-Hat-in-Classic-Mens-Style-The-Acropol-Agnoulita-Hats-1_ec1d1b53-8cb0-475c-8257-f39b36e785f5.webp?v=1726783016",
price: 315,
subtitle: "Elegant Dark Brown Fedora",
overview: "A classic dark brown fedora with a center-dent crown, ideal for those with oval faces and average height seeking a refined, timeless style."
},
{
name: "The Patron",
url: "https://www.agnoulitahats.com/products/classic-mens-fedora-hat-grey-patron",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Classic-Mens-Fedora-Hat-In-Grey-Beaver-Fur-Felt-The-Patron-Agnoulita-Hats-1.webp?v=1726002669",
price: 315,
subtitle: "Classic Grey Beaver Fur Fedora",
overview: "A timeless grey fedora made from luxurious beaver fur felt, designed to complement oval face shapes and average statures with its well-balanced proportions."
}
],
"Oval,Average,Western": [
{
name: "The Vanguard",
url: "https://www.agnoulitahats.com/products/brown-western-style-cowboy-hat-vanguard",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-Western-Style-Cowboy-Hat-in-High-Quality-Fur-Felt-The-Vanguard-Agnoulita-Hats-1.png?v=1726695763",
price: 215,
subtitle: "High-Quality Western Cowboy Hat",
overview: "A brown western-style cowboy hat featuring a telescope crown, perfect for those with oval faces and average height seeking an authentic western look."
},
{
name: "The Dakota",
url: "https://www.agnoulitahats.com/products/mens-western-fedora-dakota",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Customizable-Mens-Western-Fedora-with-Cattleman-Crown-The-Dakota-Agnoulita-Hats-1.webp?v=1726780711",
price: 215,
subtitle: "Customizable Western Fedora",
overview: "A versatile western fedora with a cattleman crown, ideal for average-height individuals with oval faces looking to blend western charm with modern style."
},
{
name: "The Renegade",
url: "https://www.agnoulitahats.com/products/clint-eastwood-inspired-cowboy-hat-renegade",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-Clint-Eastwood-Inspired-Cowboy-Hat-in-Durable-Fur-Felt-The-Renegade-Agnoulita-Hats-1_6044a878-2898-423a-97f9-671f916a5c58.webp?v=1726695713",
price: 215,
subtitle: "Clint Eastwood-Inspired Cowboy Hat",
overview: "A brown cowboy hat inspired by Clint Eastwood, offering a rugged western look that complements oval face shapes and average statures."
}
],
"Oval,Average,Vintage": [
{
name: "The Shadows",
url: "https://www.agnoulitahats.com/products/1940s-fedora-vintage-elegance-shadows",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Exquisite-1940s-Inspired-Fedora-with-Vintage-Style-The-Shadows-Agnoulita-Hats-1.png?v=1726435243",
price: 215,
subtitle: "1940s-Inspired Luxury Fedora",
overview: "An exquisite 1940s-inspired fedora that captures vintage elegance, perfect for those with oval faces and average height seeking a touch of old Hollywood glamour."
},
{
name: "The Cerebelle",
url: "https://www.agnoulitahats.com/products/fur-felt-homburg-cerebelle-oxblood",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Handcrafted-Oxblood-Fur-Felt-Homburg-with-Custom-Fit-The-Cerebelle-Agnoulita-Hats-1_611ae925-f48f-4e91-a4dd-a04d56c23356.webp?v=1725916547",
price: 215,
subtitle: "Vintage-Inspired Oxblood Homburg",
overview: "A handcrafted oxblood homburg that brings vintage charm to modern wardrobes, ideal for oval face shapes and average statures."
},
{
name: "The Savoy",
url: "https://www.agnoulitahats.com/products/brown-1940s-slope-back-fedora-savoy",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-1940s-Slope-Back-Mens-Fedora-in-Fine-Fur-Felt-The-Savoy-Agnoulita-Hats-1_077188fb-9c54-4092-b43a-f6fa0b3ff4c3.webp?v=1726262510",
price: 215,
subtitle: "1940s Slope-Back Fedora",
overview: "A brown 1940s-style fedora with a distinctive slope-back design, perfect for average-height individuals with oval faces looking to channel vintage sophistication."
}
],
"Oval,Average,Modern": [
{
name: "The Zephyr",
url: "https://www.agnoulitahats.com/products/luxurious-silk-finish-fedora-zephyr",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Denim-Blue-Luxurious-Silk-Finish-Fedora-for-Men-The-Zephyr-Agnoulita-Hats-1.webp?v=1726348739",
price: 255,
subtitle: "Luxurious Silk-Finish Fedora",
overview: "A denim blue fedora with a luxurious silk finish, offering a modern twist on classic style for those with oval faces and average height."
},
{
name: "The Taylor",
url: "https://www.agnoulitahats.com/products/burgundy-flat-brim-fedora-taylor",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Burgundy-Flat-Brim-Fedora-in-Elegant-Fur-Felt-The-Taylor-Agnoulita-Hats-1_d88c17b6-3bdb-498f-8bec-09ace06e9339.webp?v=1726694234",
price: 215,
subtitle: "Modern Flat Brim Fedora",
overview: "A burgundy flat brim fedora that offers a contemporary take on classic hat styles, ideal for oval face shapes and average statures seeking a bold look."
},
{
name: "The Hunter",
url: "https://www.agnoulitahats.com/products/dark-green-fedora-hat-hunter",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Dark-Green-Fedora-Hat-for-Men-in-Premium-Fur-Felt-The-Hunter-Agnoulita-Hats-1_feaa9168-debe-4649-b10f-625882fb0731.webp?v=1726782281",
price: 215,
subtitle: "Modern Dark Green Fedora",
overview: "A dark green fedora that brings a fresh, modern color to a classic style, perfect for those with oval faces and average height looking for a contemporary edge."
}
],
"Oval,Tall,Classic": [
{
name: "The Castor",
url: "https://www.agnoulitahats.com/products/high-crown-fedora-hat-castor-black",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Black-High-Crown-Fedora-Hat-with-Custom-Sizes-The-Castor-Agnoulita-Hats-1.webp?v=1726002624",
price: 315,
subtitle: "High Crown Black Beaver Fedora",
overview: "A luxurious black high crown fedora in beaver fur felt, perfect for tall individuals with oval faces seeking a classic, commanding look."
},
{
name: "The Williams",
url: "https://www.agnoulitahats.com/products/rolled-brim-fedora-williams-black",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Black-Rolled-Brim-Fedora-Custom-Luxury-Hat-The-Williams-Agnoulita-Hats-1_330501cb-0af5-4dc7-b624-2534dec69456.webp?v=1726003454",
price: 215,
subtitle: "Classic Rolled Brim Fedora",
overview: "An elegant black fedora with a rolled brim, ideal for tall gentlemen with oval faces looking for a timeless, sophisticated style."
},
{
name: "The Tobin",
url: "https://www.agnoulitahats.com/products/dark-purple-fur-felt-fedora-tobin",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Dark-Purple-Fur-Felt-Fedora-For-Men-The-Tobin-Agnoulita-Hats-1.webp?v=1726348437",
price: 215,
subtitle: "Bold Purple Classic Fedora",
overview: "A striking dark purple fedora with a classic design, perfect for tall individuals with oval faces who want to make a statement while maintaining a classic silhouette."
}
],

"Oval,Tall,Western": [
{
name: "The Crown",
url: "https://www.agnoulitahats.com/products/brown-wide-brim-rancher-fedora-crown",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-Wide-Brim-Rancher-Fedora-Hat-in-Durable-Fur-Felt-The-Crown-Agnoulita-Hats-1.png?v=1726435003",
price: 215,
subtitle: "Wide Brim Rancher Fedora",
overview: "A brown wide-brim rancher fedora with a tall crown, ideal for tall individuals with oval faces seeking a bold western look."
},
{
name: "The Centaur",
url: "https://www.agnoulitahats.com/products/black-western-outback-flat-brim-hat-centaur",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Black-Western-Outback-Flat-Brim-Hat-in-Durable-Fur-Felt-The-Centaur-Agnoulita-Hats-1_e258c773-3d9b-42d9-a1af-5e02fb37a2c2.png?v=1726434953",
price: 215,
subtitle: "Western Outback Flat Brim Hat",
overview: "A black western outback hat with a flat brim and tall crown, perfect for tall wearers with oval faces looking for a rugged, adventurous style."
},
{
name: "The Renegade",
url: "https://www.agnoulitahats.com/products/clint-eastwood-inspired-cowboy-hat-renegade",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-Clint-Eastwood-Inspired-Cowboy-Hat-in-Durable-Fur-Felt-The-Renegade-Agnoulita-Hats-1_6044a878-2898-423a-97f9-671f916a5c58.webp?v=1726695713",
price: 215,
subtitle: "Clint Eastwood-Inspired Cowboy Hat",
overview: "A brown cowboy hat inspired by Clint Eastwood, offering a classic western look that complements tall statures and oval face shapes."
}
],

"Oval,Tall,Vintage": [
{
name: "The Collector",
url: "https://www.agnoulitahats.com/products/vintage-fedora-hat-collector-pewter-grey",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/1920s-Inspired-Vintage-Fedora-Hat-with-Classic-Teardrop-Crown-The-Collector-Agnoulita-Hats-1_937261fc-9771-4517-ad1f-3964e23bf25c.webp?v=1726262882",
price: 215,
subtitle: "1920s-Inspired Vintage Fedora",
overview: "A 1920s-inspired fedora with a classic teardrop crown, perfect for tall individuals with oval faces seeking a touch of vintage elegance."
},
{
name: "The Ace",
url: "https://www.agnoulitahats.com/products/1940s-style-fedora-hat-mustard-beaver-fur-felt",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Vintage-1940s-Style-Fedora-Hat-in-Artisanal-Beaver-Fur-Felt-The-Ace-Agnoulita-Hats-1_182fca4e-daa1-4183-ae7f-e9ef8dc2133b.webp?v=1726782813",
price: 315,
subtitle: "1940s-Style Beaver Fur Fedora",
overview: "A vintage 1940s-style fedora crafted from artisanal beaver fur felt, ideal for tall wearers with oval faces looking to channel classic Hollywood glamour."
},
{
name: "The Falcon",
url: "https://www.agnoulitahats.com/products/iconic-bogart-fedora-hat-falcon",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Iconic-Bogart-Fedora-Hat-with-Custom-Fit-The-Falcon-Agnoulita-Hats-1.png?v=1726435193",
price: 215,
subtitle: "Iconic Bogart-Style Fedora",
overview: "A Bogart-inspired fedora that brings vintage charm to tall individuals with oval faces, perfect for those who appreciate timeless Hollywood style."
}
],
"Oval,Tall,Modern": [
{
name: "The Enigma",
url: "https://www.agnoulitahats.com/products/dusty-pink-wide-brim-felt-hat-enigma",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Dusty-Pink-Wide-Brim-Fedora-Hat-in-Premium-Fur-Felt-The-Enigma-Agnoulita-Hats-1_9e1142ec-d98d-4fc2-a090-c680de44d93c.webp?v=1726696783",
price: 215,
subtitle: "Dusty Pink Wide Brim Fedora",
overview: "Soft and sophisticated dusty pink wide-brim fedora, a unique statement of elegance perfectly crafted for the modern fashion enthusiast."
},
{
name: "The Oppenheimer",
url: "https://www.agnoulitahats.com/products/rustic-style-wide-brim-porkpie-hat-oppenheimer",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Handcrafted-Wide-Brim-Porkpie-Hat-with-Leather-Band-The-Oppenheimer-Agnoulita-Hats-1.webp?v=1727298586",
price: 315,
subtitle: "Wide Brim Porkpie Hat",
overview: "Inspired by cinematic classics, this wide brim porkpie hat combines a bold silhouette with premium beaver fur felt for rustic charm and practicality."
},
{
name: "The Ulysses",
url: "https://www.agnoulitahats.com/products/the-ulysses-wine-red-wide-brim-fedora",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Wine-Red-Wide-Brim-Fedora-Hat-with-Custom-Options-The-Ulysses-Agnoulita-Hats-1.png?v=1726781879",
price: 315,
subtitle: "Wine Red Wide Brim Fedora",
overview: "The Ulysses fedora in wine red brings a touch of boldness to your look, with its wide brim and customizable options for any occasion."
}
],
"Round,Short,Classic": [
{
name: "The Tobin",
url: "https://www.agnoulitahats.com/products/cream-fedora-hat-tobin",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Handcrafted-Cream-Fedora-Hat-in-Premium-Fur-Felt-The-Tobin-Agnoulita-Hats-1_e3482030-77f3-4a60-8502-fa6485f806eb.png?v=1726434856",
price: 215,
subtitle: "Classic Single-Crease Fedora",
overview: "Handcrafted cream fedora with a single-crease crown, perfect for adding timeless style to any outfit."
},
{
name: "The Cooper",
url: "https://www.agnoulitahats.com/products/black-low-crown-fedora-hat-cooper",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Low-Crown-Fedora-Hat-in-Black-Fur-Felt-The-Cooper-Agnoulita-Hats-1_3b92a6c0-3906-47dc-87dd-e49867bedb2e.webp?v=1726002542",
price: 215,
subtitle: "Low Crown Black Fedora",
overview: "Sleek and modern low crown fedora in black, offering a minimalist style with a comfortable fit."
},
{
name: "The Phoenix",
url: "https://www.agnoulitahats.com/products/short-brim-fedora-phoenix-light-grey",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Classic-Short-Brim-Fedora-in-Light-Grey-Fur-Felt-The-Phoenix-Agnoulita-Hats-1_d44b0278-e604-4efa-8d38-de6423f59810.webp?v=1726866770",
price: 215,
subtitle: "Classic Short Brim Fedora",
overview: "Light grey short brim fedora combining timeless style with modern elegance, perfect for any occasion."
}
],

"Round,Short,Western": [
{
name: "The Bison",
url: "https://www.agnoulitahats.com/products/western-fedora-premium-fur-felt-bison",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-Short-Brim-Western-Fedora-in-Durable-Fur-Felt-The-Bison-Agnoulita-Hats-1_2c375126-e436-42a2-b94d-5f598dd2f564.png?v=1726434621",
price: 215,
subtitle: "Short Brim Western Fedora",
overview: "Brown short brim western fedora combining classic elegance with Western style, perfect for a unique look."
},
{
name: "The Bolero",
url: "https://www.agnoulitahats.com/products/flat-crown-cowboy-hat-bolero-black",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Flat-Crown-Western-Cowboy-Hat-in-Black-Wool-Felt-The-Bolero-Agnoulita-Hats-1.webp?v=1726693735",
price: 190,
subtitle: "Flat Crown Western Cowboy Hat",
overview: "Black flat crown cowboy hat offering a timeless western look with customizable features."
},
{
name: "The Gaucho",
url: "https://www.agnoulitahats.com/products/light-brown-felt-cowboy-hat-gaucho",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Light-Brown-Felt-Cowboy-Hat-Custom-Fit-and-Durable-Style-The-Gaucho-Agnoulita-Hats-1_e709dcec-fd44-4080-904b-2ad8b5a14ca6.webp?v=1726695427",
price: 215,
subtitle: "Light Brown Felt Cowboy Hat",
overview: "Light brown felt cowboy hat with a flat crown and wired flat brim, offering style and durability for the modern-day cowboy."
}
],
"Round,Short,Vintage": [
{
name: "The Shadows",
url: "https://www.agnoulitahats.com/products/bogart-fedora-hat-shadows",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Grey-1940s-Bogart-Fedora-Hat-in-Smooth-Fur-Felt-The-Shadows-Agnoulita-Hats-1_61c3f72e-5246-4368-bd3f-8f55d727922b.webp?v=1726262224",
price: 215,
subtitle: "1940s Bogart-Style Fedora",
overview: "Grey 1940s Bogart-style fedora crafted from premium rabbit fur felt, offering vintage charm and modern craftsmanship."
},
{
name: "The Dogal",
url: "https://www.agnoulitahats.com/products/1930s-fedora-hat-dogal-caribou-grey",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Caribou-Grey-1930s-Fedora-Hat-in-Plush-Fur-Felt-The-Dogal-Agnoulita-Hats-1_4dbc9b9c-102f-47a6-99fb-c48efddef448.webp?v=1726262182",
price: 215,
subtitle: "1930s Inspired Fedora",
overview: "Caribou grey 1930's inspired fedora hat, crafted from premium rabbit fur felt with a center-dent crown and ribbon-bound snap brim."
},
{
name: "The Phaeton",
url: "https://www.agnoulitahats.com/products/1920s-mens-retro-homburg-phaeton-dark-navy-blue",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Dark-Navy-Blue-1920s-Mens-Retro-Homburg-Hat-The-Phaeton-Agnoulita-Hats-1_21540adf-bc11-4ceb-be60-2d1cd0dc8e2f.webp?v=1725829759",
price: 215,
subtitle: "1920s Retro Homburg Hat",
overview: "Dark navy blue 1920's retro homburg hat crafted from premium rabbit fur felt, combining vintage style with modern luxury."
}
],
"Round,Short,Modern": [
{
name: "The Clubber",
url: "https://www.agnoulitahats.com/products/light-pink-fedora-hat-clubber",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Light-Pink-Fedora-with-Medium-Crown-in-Luxurious-Fur-Felt-The-Clubber-Agnoulita-Hats-1_1773d9af-238a-4daf-bd0b-c065fc46079c.webp?v=1726782676",
price: 215,
subtitle: "Light Pink Medium Crown Fedora",
overview: "Light pink fedora with a medium crown and upturned brim, combining style, elegance, and comfort for any occasion."
},
{
name: "The Equinox",
url: "https://www.agnoulitahats.com/products/fuchsia-fedora-hat-equinox",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Stylish-Fuchsia-Fedora-Hat-with-Custom-Fit-The-Equinox-Agnoulita-Hats-1_1c4ab564-3455-4490-b0f9-b5ab7aac574b.webp?v=1726782429",
price: 215,
subtitle: "Stylish Fuchsia Fedora",
overview: "Bold fuchsia fedora with a custom fit, blending modern fashion and classic elegance for a statement-making accessory."
},
{
name: "The Taylor",
url: "https://www.agnoulitahats.com/products/navy-blue-flat-brim-fedora-hat-taylor",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Navy-Blue-Flat-Brim-Fedora-Hat-in-Stylish-Fur-Felt-The-Taylor-Agnoulita-Hats-1.webp?v=1726694370",
price: 215,
subtitle: "Navy Blue Flat Brim Fedora",
overview: "Navy blue flat brim fedora with a modern edge, perfect for those who like their style with a bit of attitude."
}
],
"Round,Average,Classic": [
{
name: "The Pathfinder",
url: "https://www.agnoulitahats.com/products/wide-brim-fedora-mens-style-pathfinder-brown",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-Wide-Brim-Fedora-in-Classic-Mens-Style-The-Pathfinder-Agnoulita-Hats-1_76052294-66c9-45a9-9008-d38e627e6555.webp?v=1726262460",
price: 215,
subtitle: "Classic Wide Brim Fedora",
overview: "Brown wide brim fedora with a teardrop crown, blending style and sun protection for every occasion."
},
{
name: "The Diplomat",
url: "https://www.agnoulitahats.com/products/mens-teardrop-fedora-diplomat-dark-grey",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Dark-Slate-Grey-Mens-Teardrop-Fedora-in-Smooth-Fur-Felt-The-Diplomat-Agnoulita-Hats-1_102c2463-8ff0-4515-b74e-5247fa777bc2.webp?v=1726607265",
price: 215,
subtitle: "Elegant Teardrop Fedora",
overview: "Dark slate grey teardrop fedora offering a sophisticated silhouette and custom fit, blending timeless elegance with modern comfort."
},
{
name: "The Aerolithe",
url: "https://www.agnoulitahats.com/products/homburg-fedora-hat-aerolithe-light-grey",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Silver-Grey-Homburg-Fedora-Hat-in-Smooth-Fur-Felt-The-Aerolithe-Agnoulita-Hats-1_8c2f0fd8-6dcb-4cbb-a5c4-d5248bed3a20.png?v=1726002587",
price: 215,
subtitle: "Silver Grey Homburg Fedora",
overview: "Sleek silver grey homburg fedora with a center-dent crown, offering a classic style with a modern twist."
}
],
"Round,Average,Western": [
{
name: "The Renegade",
url: "https://www.agnoulitahats.com/products/clint-eastwood-inspired-cowboy-hat-renegade",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-Clint-Eastwood-Inspired-Cowboy-Hat-in-Durable-Fur-Felt-The-Renegade-Agnoulita-Hats-1_6044a878-2898-423a-97f9-671f916a5c58.webp?v=1726695713",
price: 215,
subtitle: "Clint Eastwood-Inspired Cowboy Hat",
overview: "Brown cowboy hat inspired by Clint Eastwood, offering timeless style with durability for outdoor adventures."
},
{
name: "The Vanguard",
url: "https://www.agnoulitahats.com/products/brown-western-style-cowboy-hat-vanguard",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-Western-Style-Cowboy-Hat-in-High-Quality-Fur-Felt-The-Vanguard-Agnoulita-Hats-1.png?v=1726695763",
price: 215,
subtitle: "High-Quality Western Cowboy Hat",
overview: "Brown western cowboy hat crafted from high-quality rabbit fur felt, blending classic western style with modern sophistication."
},
{
name: "The Mestizo",
url: "https://www.agnoulitahats.com/products/flat-brim-western-hat-mestizo",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Burgundy-Western-Style-Flat-Brim-Hat-in-Premium-Wool-Felt-The-Mestizo-Agnoulita-Hats-1.webp?v=1726780042",
price: 190,
subtitle: "Burgundy Flat Brim Western Hat",
overview: "Burgundy flat brim western hat handcrafted from premium wool felt, blending Western style with modern craftsmanship."
}
],
"Round,Average,Vintage": [
{
name: "The Phaeton",
url: "https://www.agnoulitahats.com/products/1920s-mens-retro-homburg-phaeton-dark-navy-blue",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Dark-Navy-Blue-1920s-Mens-Retro-Homburg-Hat-The-Phaeton-Agnoulita-Hats-1_21540adf-bc11-4ceb-be60-2d1cd0dc8e2f.webp?v=1725829759",
price: 215,
subtitle: "Dark Navy Blue 1920's Men's Retro Homburg Hat",
overview: "The Phaeton is a dark navy blue 1920's retro homburg hat crafted from premium rabbit fur felt, featuring a center-dent crown and ribbon-bound rolled brim. Custom-made for a perfect fit, this hat combines vintage style with modern luxury."
},
{
name: "The Shadows",
url: "https://www.agnoulitahats.com/products/bogart-fedora-hat-shadows",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Grey-1940s-Bogart-Fedora-Hat-in-Smooth-Fur-Felt-The-Shadows-Agnoulita-Hats-1_61c3f72e-5246-4368-bd3f-8f55d727922b.webp?v=1726262224",
price: 215,
subtitle: "Grey 1940s Bogart Fedora Hat in Smooth Fur Felt",
overview: "The Shadows is a grey 1940s Bogart-style fedora crafted from premium rabbit fur felt, featuring a teardrop crown and raw-edge snap brim. Custom-made for a perfect fit, this fedora offers vintage charm and modern craftsmanship for any occasion."
},
{
name: "The Gin Joint",
url: "https://www.agnoulitahats.com/products/bogart-fedora-hat-film-noir-style-gin-joint",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Stylish-Bogart-Fedora-Hat-in-Grey-Fur-Felt-The-Gin-Joint-Agnoulita-Hats-1_4e8597fb-e546-4942-95e3-e40719b12a2d.webp?v=1726262096",
price: 215,
subtitle: "Stylish Bogart Fedora Hat in Grey Fur Felt",
overview: "The Gin Joint Bogart fedora brings the allure of classic cinema to your wardrobe. In sleek grey felt with a timeless silhouette, it's the perfect hat for those who appreciate vintage style with a modern twist."
}
],
"Round,Average,Modern": [
{
name: "The Equinox",
url: "https://www.agnoulitahats.com/products/royal-blue-fedora-hat-equinox",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Stylish-Royal-Blue-Fedora-Hat-with-Teardrop-Crown-The-Equinox-Agnoulita-Hats-1.webp?v=1727298681",
price: 215,
subtitle: "Stylish Royal Blue Fedora Hat with Teardrop Crown",
overview: "The Equinox fedora in royal blue brings a pop of color to classic style. It's the perfect choice for those who love to make a bold statement while keeping things effortlessly cool and comfortable."
},
{
name: "The Taylor",
url: "https://www.agnoulitahats.com/products/burgundy-flat-brim-fedora-taylor",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Burgundy-Flat-Brim-Fedora-in-Elegant-Fur-Felt-The-Taylor-Agnoulita-Hats-1_d88c17b6-3bdb-498f-8bec-09ace06e9339.webp?v=1726694234",
price: 215,
subtitle: "Burgundy Flat Brim Fedora in Elegant Fur Felt",
overview: "The Taylor is a burgundy flat brim fedora handcrafted from luxurious rabbit fur felt. Featuring a center-dent crown and steel-wired brim, this custom-made hat offers a blend of elegance and practicality for any occasion."
},
{
name: "The Sovereign",
url: "https://www.agnoulitahats.com/products/forest-green-snap-brim-fedora-sovereign",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Forest-Green-Snap-Brim-Fedora-in-Stylish-Fur-Felt-The-Sovereign-Agnoulita-Hats-1.webp?v=1726348617",
price: 215,
subtitle: "Forest Green Snap Brim Fedora in Stylish Fur Felt",
overview: "The Sovereign is a forest green snap brim fedora crafted from premium rabbit fur felt, featuring a teardrop crown and underwelt snap brim. Custom-made for a perfect fit, this hat combines classic elegance with modern comfort, making it a standout accessory."
}
],
"Round,Tall,Classic": [
{
name: "The Castor",
url: "https://www.agnoulitahats.com/products/high-crown-fedora-hat-castor-black",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Black-High-Crown-Fedora-Hat-with-Custom-Sizes-The-Castor-Agnoulita-Hats-1.webp?v=1726002624",
price: 315,
subtitle: "High Crown Black Fedora",
overview: "Handcrafted from black beaver fur felt, the Castor offers a bold, high crown design with a custom fit, perfect for formal occasions."
},
{
name: "The Tobin",
url: "https://www.agnoulitahats.com/products/black-mens-fedora-hat-tobin",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Black-Mens-Fedora-Hat-with-Single-Crease-Crown-The-Tobin-Agnoulita-Hats-1.webp?v=1726348021",
price: 215,
subtitle: "Single Crease Black Fedora",
overview: "Black fedora hat featuring a single crease crown and wide snap brim, combining iconic style with modern sophistication."
},
{
name: "The Ambassador",
url: "https://www.agnoulitahats.com/products/fur-felt-homburg-hat-ambassador",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Grey-Homburg-Hat-in-Rich-Beaver-Fur-Felt-The-Ambassador-Agnoulita-Hats-1_24077553-f025-4b18-9375-40144b3f8403.webp?v=1726349459",
price: 315,
subtitle: "Grey Beaver Fur Homburg",
overview: "Grey homburg hat made from premium beaver fur felt, featuring a single-crease crown and ribbon-bound rolled brim for timeless elegance."
}
],
"Round,Tall,Western": [
{
name: "The Caribou",
url: "https://www.agnoulitahats.com/products/ound-crown-western-style-hat-caribou",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Round-Crown-Western-Style-Hat-in-Fur-Felt-The-Caribou-Agnoulita-Hats-1_96005cca-294b-4a75-ba8a-a9758b17c389.webp?v=1726866481",
price: 215,
subtitle: "Round Crown Western Hat",
overview: "Bold round crown western hat with a wide brim, perfect for making a statement in both trail and city settings."
},
{
name: "The Prairie",
url: "https://www.agnoulitahats.com/products/custom-design-wide-brim-rancher-fedora-hat-prairie",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Light-Brown-Custom-Design-Wide-Brim-Rancher-Fedora-Hat-The-Prairie-Agnoulita-Hats-1.png?v=1726435344",
price: 215,
subtitle: "Wide Brim Rancher Fedora",
overview: "Light brown wide-brim rancher fedora crafted from luxurious fur felt, offering both a rugged and stylish look for upscale outdoor events."
},
{
name: "The Indian",
url: "https://www.agnoulitahats.com/products/black-open-crown-cowboy-hat-indian",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Black-Open-Crown-Cowboy-Hat-in-Malleable-Fur-Felt-The-Indian-Agnoulita-Hats-1.webp?v=1726780999",
price: 215,
subtitle: "Open Crown Cowboy Hat",
overview: "Black open crown cowboy hat crafted from premium rabbit fur felt, combining rugged style with modern comfort for any occasion."
}
],
"Round,Tall,Vintage": [
{
name: "The Collector",
url: "https://www.agnoulitahats.com/products/vintage-fedora-hat-collector-pewter-grey",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/1920s-Inspired-Vintage-Fedora-Hat-with-Classic-Teardrop-Crown-The-Collector-Agnoulita-Hats-1_937261fc-9771-4517-ad1f-3964e23bf25c.webp?v=1726262882",
price: 215,
subtitle: "1920s Inspired Vintage Fedora",
overview: "Inspired by the elegance of the roaring twenties, this teardrop-crowned fedora blends vintage style with modern craftsmanship."
},
{
name: "The Miller",
url: "https://www.agnoulitahats.com/products/1920s-fedora-hat-miller",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/1920s-Mens-Fedora-Hat-in-Malleable-Beaver-Fur-Felt-The-Miller-Agnoulita-Hats-1_d0dc892a-87dd-4eb7-8429-70f3f88d0fe7.webp?v=1726782766",
price: 315,
subtitle: "1920s Beaver Fur Fedora",
overview: "Inspired by the 1920s, the Miller fedora is handcrafted from premium beaver fur felt for a timeless look with a cattleman crown and custom fit."
},
{
name: "The Grandmaster",
url: "https://www.agnoulitahats.com/products/1920s-retro-homburg-hat-grandmaster",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/1920s-Style-Homburg-Hat-in-Luxurious-Beaver-Fur-Felt-The-Grandmaster-Agnoulita-Hats-1_e6fd58cd-a193-49b9-b741-3527bbffd052.webp?v=1726003569",
price: 315,
subtitle: "1920s Style Beaver Fur Homburg",
overview: "Inspired by the elegance of the 1920s, the Grandmaster is a meticulously handcrafted homburg hat made from luxurious beaver fur felt."
}
],
"Round,Tall,Modern": [
{
name: "The Ulysses",
url: "https://www.agnoulitahats.com/products/the-ulysses-wine-red-wide-brim-fedora",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Wine-Red-Wide-Brim-Fedora-Hat-with-Custom-Options-The-Ulysses-Agnoulita-Hats-1.png?v=1726781879",
price: 315,
subtitle: "Wine Red Wide Brim Fedora",
overview: "The Ulysses fedora in wine red brings a touch of boldness to your look, with its wide brim and customizable options for any occasion."
},
{
name: "The Oppenheimer",
url: "https://www.agnoulitahats.com/products/rustic-style-wide-brim-porkpie-hat-oppenheimer",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Handcrafted-Wide-Brim-Porkpie-Hat-with-Leather-Band-The-Oppenheimer-Agnoulita-Hats-1.webp?v=1727298586",
price: 315,
subtitle: "Wide Brim Porkpie Hat",
overview: "Inspired by cinematic classics, this wide brim porkpie hat combines a bold silhouette with premium beaver fur felt for rustic charm and practicality."
},
{
name: "The Enigma",
url: "https://www.agnoulitahats.com/products/beige-wide-brim-fedora-hat-enigma",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Beige-Wide-Brim-Fedora-Hat-in-Premium-Fur-Felt-The-Enigma-Agnoulita-Hats-1_b7094b48-4c41-43da-90bd-3a39d1858b07.webp?v=1726696831",
price: 215,
subtitle: "Beige Wide Brim Fedora",
overview: "The Enigma, a beige wide brim fedora made from premium rabbit fur felt, offers a bold and distinctive look that complements tall statures and round faces."
}
],
"Square,Short,Classic": [
{
name: "The Cooper",
url: "https://www.agnoulitahats.com/products/black-low-crown-fedora-hat-cooper",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Low-Crown-Fedora-Hat-in-Black-Fur-Felt-The-Cooper-Agnoulita-Hats-1_3b92a6c0-3906-47dc-87dd-e49867bedb2e.webp?v=1726002542",
price: 215,
subtitle: "Low Crown Black Fedora",
overview: "Sleek and modern low crown fedora in black, offering a minimalist style with a comfortable fit for a shorter stature."
},
{
name: "The Phoenix",
url: "https://www.agnoulitahats.com/products/short-brim-fedora-phoenix-light-grey",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Classic-Short-Brim-Fedora-in-Light-Grey-Fur-Felt-The-Phoenix-Agnoulita-Hats-1_d44b0278-e604-4efa-8d38-de6423f59810.webp?v=1726866770",
price: 215,
subtitle: "Classic Short Brim Fedora",
overview: "The Phoenix is a light grey short brim fedora made from luxurious rabbit fur felt, featuring a medium crown and snap brim."
},
{
name: "The Coke",
url: "https://www.agnoulitahats.com/products/classic-black-bowler-hat-coke",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Classic-Bowler-Hat-for-Men-in-Black-Fur-Felt-The-Coke-Agnoulita-Hats-1.webp?v=1725829676",
price: 215,
subtitle: "Classic Black Bowler Hat",
overview: "Classic black bowler hat crafted from premium fur felt, featuring an iconic hard shell and rounded crown, perfect for adding structure to square faces."
}
],
"Square,Short,Western": [
{
name: "The Mestizo",
url: "https://www.agnoulitahats.com/products/flat-brim-western-hat-mestizo",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Burgundy-Western-Style-Flat-Brim-Hat-in-Premium-Wool-Felt-The-Mestizo-Agnoulita-Hats-1.webp?v=1726780042",
price: 190,
subtitle: "Burgundy Flat Brim Western Hat",
overview: "Burgundy flat brim western hat handcrafted from premium wool felt, blending Western style with modern craftsmanship for a bold look."
},
{
name: "The Bolero",
url: "https://www.agnoulitahats.com/products/flat-crown-cowboy-hat-bolero-black",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Flat-Crown-Western-Cowboy-Hat-in-Black-Wool-Felt-The-Bolero-Agnoulita-Hats-1.webp?v=1726693735",
price: 190,
subtitle: "Flat Crown Western Cowboy Hat",
overview: "Black flat crown cowboy hat offering a timeless western look with customizable features, ideal for adding width to square faces."
},
{
name: "The Bison",
url: "https://www.agnoulitahats.com/products/western-fedora-premium-fur-felt-bison",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-Short-Brim-Western-Fedora-in-Durable-Fur-Felt-The-Bison-Agnoulita-Hats-1_2c375126-e436-42a2-b94d-5f598dd2f564.png?v=1726434621",
price: 215,
subtitle: "Short Brim Western Fedora",
overview: "Brown short brim western fedora combining classic elegance with Western style, perfect for a unique look that complements shorter stature."
}
],
"Square,Short,Vintage": [
{
name: "The Pandamator",
url: "https://www.agnoulitahats.com/products/vintage-style-fedora-hat-agnoulita-pandamator-shark-gills",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Mens-Vintage-Charm-Fedora-Hat-with-Shark-Gills-Hatband-The-Pandamator-Agnoulita-Hats-1.webp?v=1725915982",
price: 215,
subtitle: "Vintage Charm Fedora with Shark-Gills Hatband",
overview: "Vintage-inspired fedora with unique shark-gills hatband, offering a blend of classic style and modern twist, suitable for square faces."
},
{
name: "The Antico",
url: "https://www.agnoulitahats.com/products/brown-classic-porkpie-hat-custom-fit",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-Classic-Porkpie-Fedora-Hat-in-Premium-Wool-Felt-The-Antico-Agnoulita-Hats-1.webp?v=1726780513",
price: 190,
subtitle: "Black Casual Porkpie Hat",
overview: "Black casual porkpie hat with a telescope crown, custom-made for perfect comfort and style, ideal for adding vintage flair to shorter statures."
},
{
name: "The Crab",
url: "https://www.agnoulitahats.com/products/black-stingy-brim-boston-trilby-crab",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Black-Stingy-Brim-Boston-Trilby-with-Feather-in-Wool-Felt-The-Crab-Agnoulita-Hats-1_5f83e3e7-dc52-4858-a29d-e1a4827d0217.webp?v=1726003040",
price: 190,
subtitle: "Black Stingy Brim Boston Trilby",
overview: "Black stingy brim Boston trilby crafted from premium wool felt, featuring a feather accent for a chic vintage look that complements square faces."
}
],
"Square,Short,Modern": [
{
name: "The Clubber",
url: "https://www.agnoulitahats.com/products/light-pink-fedora-hat-clubber",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Light-Pink-Fedora-with-Medium-Crown-in-Luxurious-Fur-Felt-The-Clubber-Agnoulita-Hats-1_1773d9af-238a-4daf-bd0b-c065fc46079c.webp?v=1726782676",
price: 215,
subtitle: "Light Pink Medium Crown Fedora",
overview: "Light pink fedora with a medium crown and upturned brim, combining style, elegance, and comfort for a modern look that flatters square faces."
},
{
name: "The Equinox",
url: "https://www.agnoulitahats.com/products/fuchsia-fedora-hat-equinox",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Stylish-Fuchsia-Fedora-Hat-with-Custom-Fit-The-Equinox-Agnoulita-Hats-1_1c4ab564-3455-4490-b0f9-b5ab7aac574b.webp?v=1726782429",
price: 215,
subtitle: "Stylish Fuchsia Fedora",
overview: "Bold fuchsia fedora with a custom fit, blending modern fashion and classic elegance for a statement-making accessory that adds height to shorter statures."
},
{
name: "The Topnote",
url: "https://www.agnoulitahats.com/products/modern-porkpie-hat-telescope-crown-design-topnote",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Olive-Green-Modern-Porkpie-Hat-with-Telescope-Crown-The-Topnote-Agnoulita-Hats-1_a2dcc3f1-c32e-4183-a6bf-331b2f90efe5.webp?v=1726782629",
price: 190,
subtitle: "Olive Green Modern Porkpie Hat",
overview: "Olive green porkpie hat with a modern telescope crown, offering a perfect blend of style and comfort for the fashion-forward individual with a square face."
}
],
"Square,Average,Classic": [
{
name: "The Diplomat",
url: "https://www.agnoulitahats.com/products/mens-teardrop-fedora-diplomat-dark-grey",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Dark-Slate-Grey-Mens-Teardrop-Fedora-in-Smooth-Fur-Felt-The-Diplomat-Agnoulita-Hats-1_102c2463-8ff0-4515-b74e-5247fa777bc2.webp?v=1726607265",
price: 215,
subtitle: "Elegant Teardrop Fedora",
overview: "Dark slate grey teardrop fedora offering a sophisticated silhouette and custom fit, blending timeless elegance with modern comfort to soften square facial features."
},
{
name: "The Aerolithe",
url: "https://www.agnoulitahats.com/products/homburg-fedora-hat-aerolithe-light-grey",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Silver-Grey-Homburg-Fedora-Hat-in-Smooth-Fur-Felt-The-Aerolithe-Agnoulita-Hats-1_8c2f0fd8-6dcb-4cbb-a5c4-d5248bed3a20.png?v=1726002587",
price: 215,
subtitle: "Silver Grey Homburg Fedora",
overview: "Sleek silver grey homburg fedora with a center-dent crown, offering a classic style with a modern twist that complements square faces."
},
{
name: "The Coke",
url: "https://www.agnoulitahats.com/products/grey-mens-bowler-hat-coke",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Pewter-Grey-Mens-Bowler-Hat-in-Stylish-Fur-Felt-The-Coke-Agnoulita-Hats-1.webp?v=1725829922",
price: 215,
subtitle: "Pewter Grey Bowler Hat",
overview: "Stylish pewter grey bowler hat crafted from premium rabbit fur felt, offering classic design and custom-made fit that softens square facial features."
}
],
"Square,Average,Western": [
{
name: "The Vanguard",
url: "https://www.agnoulitahats.com/products/brown-western-style-cowboy-hat-vanguard",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-Western-Style-Cowboy-Hat-in-High-Quality-Fur-Felt-The-Vanguard-Agnoulita-Hats-1.png?v=1726695763",
price: 215,
subtitle: "High-Quality Western Cowboy Hat",
overview: "Brown western cowboy hat crafted from high-quality rabbit fur felt, blending classic western style with modern sophistication to complement square faces."
},
{
name: "The Vista",
url: "https://www.agnoulitahats.com/products/burgundy-classic-cowboy-style-gambler-hat-vista",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Burgundy-Classic-Cowboy-Style-Gambler-Hat-in-Fur-Felt-The-Vista-Agnoulita-Hats-1_d1736b3d-f8be-43d4-81f2-2ee2dec57b86.webp?v=1726695297",
price: 215,
subtitle: "Burgundy Classic Cowboy Gambler Hat",
overview: "Burgundy cowboy-style gambler hat crafted from premium rabbit fur felt, featuring a telescope crown and rolled brim that softens square facial features."
},
{
name: "The Desperado",
url: "https://www.agnoulitahats.com/products/outback-fedora-hat-desperado-light-brown",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Light-Brown-Outback-Fedora-Hat-in-Durable-Fur-Felt-The-Desperado-Agnoulita-Hats-1_aa05db53-9b4e-487f-bd1e-2e6132e2c41a.webp?v=1726696726",
price: 215,
subtitle: "Light Brown Outback Fedora",
overview: "Classic and dependable light brown outback fedora, offering the perfect balance of durability and style for outdoor adventures while flattering square faces."
}
],
"Square,Average,Vintage": [
{
name: "The Silkstone",
url: "https://www.agnoulitahats.com/products/1940s-fedora-hat-silkstone-brown",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-1940s-Fedora-Hat-Custom-Crafted-The-Silkstone-Agnoulita-Hats-1_55c804f0-0f2b-4532-8c54-8084d082a8a4.webp?v=1726262364",
price: 215,
subtitle: "1940s-Inspired Brown Fedora",
overview: "Brown 1940s fedora hat handcrafted from premium rabbit fur felt, combining vintage elegance with modern craftsmanship to soften square facial features."
},
{
name: "The Savoy",
url: "https://www.agnoulitahats.com/products/brown-1940s-slope-back-fedora-savoy",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-1940s-Slope-Back-Mens-Fedora-in-Fine-Fur-Felt-The-Savoy-Agnoulita-Hats-1_077188fb-9c54-4092-b43a-f6fa0b3ff4c3.webp?v=1726262510",
price: 215,
subtitle: "1940s Slope-Back Fedora",
overview: "Brown 1940s-inspired fedora with a stylish slope-back design, perfect for vintage aficionados seeking elegance and complementing square faces."
},
{
name: "The Phaeton",
url: "https://www.agnoulitahats.com/products/retro-homburg-hat-men-phaeton-desert-taupe",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Retro-Homburg-Hat-for-Men-in-Premium-Fur-Felt-The-Phaeton-Agnoulita-Hats-1_1ac2a984-bbca-40ad-a783-c913e1469904.webp?v=1725830003",
price: 215,
subtitle: "Retro Homburg Hat",
overview: "Retro homburg hat for men, handcrafted from premium rabbit fur felt, combining vintage elegance with modern comfort to flatter square facial features."
}
],
"Square,Average,Modern": [
{
name: "The Sovereign",
url: "https://www.agnoulitahats.com/products/forest-green-snap-brim-fedora-sovereign",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Forest-Green-Snap-Brim-Fedora-in-Stylish-Fur-Felt-The-Sovereign-Agnoulita-Hats-1.webp?v=1726348617",
price: 215,
subtitle: "Forest Green Snap Brim Fedora",
overview: "Forest green snap brim fedora crafted from premium rabbit fur felt, combining classic elegance with modern comfort for a standout accessory that flatters square faces."
},
{
name: "The Taylor",
url: "https://www.agnoulitahats.com/products/burgundy-flat-brim-fedora-taylor",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Burgundy-Flat-Brim-Fedora-in-Elegant-Fur-Felt-The-Taylor-Agnoulita-Hats-1_d88c17b6-3bdb-498f-8bec-09ace06e9339.webp?v=1726694234",
price: 215,
subtitle: "Burgundy Flat Brim Fedora",
overview: "Burgundy flat brim fedora handcrafted from luxurious rabbit fur felt, offering a blend of elegance and practicality for any occasion while complementing square faces."
},
{
name: "The Zephyr",
url: "https://www.agnoulitahats.com/products/luxurious-silk-finish-fedora-zephyr",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Denim-Blue-Luxurious-Silk-Finish-Fedora-for-Men-The-Zephyr-Agnoulita-Hats-1.webp?v=1726348739",
price: 255,
subtitle: "Denim Blue Silk Finish Fedora",
overview: "Customizable denim blue silk finish fedora made from a luxurious rabbit-hare blend felt, offering a personalized fit and timeless sophistication that softens square facial features."
}
],
"Square,Tall,Classic": [
{
name: "The Castor",
url: "https://www.agnoulitahats.com/products/high-crown-fedora-hat-castor-black",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Black-High-Crown-Fedora-Hat-with-Custom-Sizes-The-Castor-Agnoulita-Hats-1.webp?v=1726002624",
price: 315,
subtitle: "High Crown Black Fedora",
overview: "Handcrafted from black beaver fur felt, the Castor offers a bold, high crown design with a custom fit, perfect for tall statures and softening square facial features."
},
{
name: "The Pathfinder",
url: "https://www.agnoulitahats.com/products/wide-brim-fedora-mens-style-pathfinder-brown",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-Wide-Brim-Fedora-in-Classic-Mens-Style-The-Pathfinder-Agnoulita-Hats-1_76052294-66c9-45a9-9008-d38e627e6555.webp?v=1726262460",
price: 215,
subtitle: "Classic Wide Brim Fedora",
overview: "Brown wide brim fedora with a teardrop crown, blending style and sun protection for every occasion while complementing tall statures and square faces."
},
{
name: "The Ambassador",
url: "https://www.agnoulitahats.com/products/grey-homburg-hat-beaver-fur-felt",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Grey-Homburg-Hat-in-Rich-Beaver-Fur-Felt-The-Ambassador-Agnoulita-Hats-1_24077553-f025-4b18-9375-40144b3f8403.webp?v=1726349459",
price: 315,
subtitle: "Grey Beaver Fur Homburg",
overview: "Grey homburg hat made from premium beaver fur felt, featuring a single-crease crown and ribbon-bound rolled brim for timeless elegance that suits tall statures."
}
],
"Square,Tall,Western": [
{
name: "The Caribou",
url: "https://www.agnoulitahats.com/products/ound-crown-western-style-hat-caribou",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Round-Crown-Western-Style-Hat-in-Fur-Felt-The-Caribou-Agnoulita-Hats-1_96005cca-294b-4a75-ba8a-a9758b17c389.webp?v=1726866481",
price: 215,
subtitle: "Round Crown Western Hat",
overview: "Bold round crown western hat with a wide brim, perfect for making a statement and complementing tall statures while softening square facial features."
},
{
name: "The Talisman",
url: "https://www.agnoulitahats.com/products/western-country-hat-talisman-pewter-grey",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Weather-Resistant-Western-Country-Hat-for-All-Seasons-The-Talisman-Agnoulita-Hats-1.webp?v=1727384946",
price: 215,
subtitle: "Weather-Resistant Western Country Hat",
overview: "Built for the outdoors, this weather-resistant hat is perfect for any season, offering style and protection while flattering tall statures and square faces."
},
{
name: "The Centaur",
url: "https://www.agnoulitahats.com/products/black-western-outback-flat-brim-hat-centaur",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Black-Western-Outback-Flat-Brim-Hat-in-Durable-Fur-Felt-The-Centaur-Agnoulita-Hats-1_e258c773-3d9b-42d9-a1af-5e02fb37a2c2.png?v=1726434953",
price: 215,
subtitle: "Black Western Outback Flat Brim Hat",
overview: "Black western outback flat brim hat handcrafted from durable rabbit fur felt, offering rugged style with a touch of elegance for tall statures."
}
],
"Square,Tall,Vintage": [
{
name: "The Collector",
url: "https://www.agnoulitahats.com/products/vintage-fedora-hat-collector-pewter-grey",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/1920s-Inspired-Vintage-Fedora-Hat-with-Classic-Teardrop-Crown-The-Collector-Agnoulita-Hats-1_937261fc-9771-4517-ad1f-3964e23bf25c.webp?v=1726262882",
price: 215,
subtitle: "1920s Inspired Vintage Fedora",
overview: "Inspired by the elegance of the roaring twenties, this teardrop-crowned fedora blends vintage style with modern craftsmanship, perfect for tall statures and square faces."
},
{
name: "The Miller",
url: "https://www.agnoulitahats.com/products/1920s-fedora-hat-miller",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/1920s-Mens-Fedora-Hat-in-Malleable-Beaver-Fur-Felt-The-Miller-Agnoulita-Hats-1_d0dc892a-87dd-4eb7-8429-70f3f88d0fe7.webp?v=1726782766",
price: 315,
subtitle: "1920s Beaver Fur Fedora",
overview: "Inspired by the 1920s, the Miller fedora is handcrafted from premium beaver fur felt for a timeless look with a cattleman crown, complementing tall statures."
},
{
name: "The Shadows",
url: "https://www.agnoulitahats.com/products/1940s-fedora-vintage-elegance-shadows",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Exquisite-1940s-Inspired-Fedora-with-Vintage-Style-The-Shadows-Agnoulita-Hats-1.png?v=1726435243",
price: 215,
subtitle: "1940s Inspired Luxury Fedora",
overview: "A true nod to the 1940s, the Shadows fedora offers vintage flair with premium materials, perfect for tall statures and softening square facial features."
}
],
"Square,Tall,Modern": [
{
name: "The Ulysses",
url: "https://www.agnoulitahats.com/products/the-ulysses-wine-red-wide-brim-fedora",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Wine-Red-Wide-Brim-Fedora-Hat-with-Custom-Options-The-Ulysses-Agnoulita-Hats-1.png?v=1726781879",
price: 315,
subtitle: "Wine Red Wide Brim Fedora",
overview: "The Ulysses fedora in wine red brings a touch of boldness to your look, with its wide brim and customizable options, perfect for tall statures and square faces."
},
{
name: "The Oppenheimer",
url: "https://www.agnoulitahats.com/products/rustic-style-wide-brim-porkpie-hat-oppenheimer",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Handcrafted-Wide-Brim-Porkpie-Hat-with-Leather-Band-The-Oppenheimer-Agnoulita-Hats-1.webp?v=1727298586",
price: 315,
subtitle: "Wide Brim Porkpie Hat",
overview: "Inspired by cinematic classics, this wide brim porkpie hat combines a bold silhouette with premium beaver fur felt, ideal for tall statures and softening square faces."
},
{
name: "The Enigma",
url: "https://www.agnoulitahats.com/products/beige-wide-brim-fedora-hat-enigma",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Beige-Wide-Brim-Fedora-Hat-in-Premium-Fur-Felt-The-Enigma-Agnoulita-Hats-1_b7094b48-4c41-43da-90bd-3a39d1858b07.webp?v=1726696831",
price: 215,
subtitle: "Beige Wide Brim Fedora",
overview: "The Enigma, a beige wide brim fedora made from premium rabbit fur felt, offers a bold and distinctive look that complements tall statures and square faces."
}
],
"Heart,Short,Classic": [
{
name: "The Diplomat",
url: "https://www.agnoulitahats.com/products/mens-teardrop-fedora-diplomat-dark-grey",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Dark-Slate-Grey-Mens-Teardrop-Fedora-in-Smooth-Fur-Felt-The-Diplomat-Agnoulita-Hats-1_102c2463-8ff0-4515-b74e-5247fa777bc2.webp?v=1726607265",
price: 215,
subtitle: "Dark Slate Grey Men's Teardrop Fedora",
overview: "Handcrafted from premium rabbit fur felt, the Diplomat teardrop fedora offers a sophisticated silhouette and custom fit. This dark slate grey fedora blends timeless elegance with modern comfort."
},
{
name: "The Phoenix",
url: "https://www.agnoulitahats.com/products/short-brim-fedora-phoenix-light-grey",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Classic-Short-Brim-Fedora-in-Light-Grey-Fur-Felt-The-Phoenix-Agnoulita-Hats-1_d44b0278-e604-4efa-8d38-de6423f59810.webp?v=1726866770",
price: 215,
subtitle: "Classic Short Brim Fedora in Light Grey",
overview: "The Phoenix is a light grey short brim fedora made from luxurious rabbit fur felt, featuring a 4 3/4 inch crown and a 2 1/4 inch snap brim. Custom-made for a perfect fit, this hat combines timeless style with modern elegance."
},
{
name: "The Cooper",
url: "https://www.agnoulitahats.com/products/black-low-crown-fedora-hat-cooper",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Low-Crown-Fedora-Hat-in-Black-Fur-Felt-The-Cooper-Agnoulita-Hats-1_3b92a6c0-3906-47dc-87dd-e49867bedb2e.webp?v=1726002542",
price: 215,
subtitle: "Low Crown Fedora Hat in Black",
overview: "The Cooper is a low crown fedora hat in black rabbit fur felt, offering a sleek and modern look with a minimalist ash grosgrain ribbon. Custom-made for comfort, this hat combines practicality and sophistication."
}
],
"Heart,Short,Western": [
{
name: "The Bison",
url: "https://www.agnoulitahats.com/products/western-fedora-premium-fur-felt-bison",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-Short-Brim-Western-Fedora-in-Durable-Fur-Felt-The-Bison-Agnoulita-Hats-1_2c375126-e436-42a2-b94d-5f598dd2f564.png?v=1726434621",
price: 215,
subtitle: "Brown Short Brim Western Fedora",
overview: "The Bison, a brown short brim western fedora handcrafted from durable fur felt, combines classic elegance with Western style. Custom-made for a perfect fit, this hat offers comfort, quality, and individuality."
},
{
name: "The Voodoo",
url: "https://www.agnoulitahats.com/products/dark-grey-telescope-crown-country-hat-voodoo",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Dark-Grey-Telescope-Crown-Country-Style-Fur-Felt-Hat-The-Voodoo-Agnoulita-Hats-1.webp?v=1726695032",
price: 215,
subtitle: "Dark Grey Telescope Crown Country Style Hat",
overview: "The Voodoo is a dark grey telescope crown country hat crafted from premium rabbit fur felt, featuring a 3 3/4 inch crown and a 2 5/8 inch raw-edge flat brim. Custom-made for a perfect fit, this hat offers a blend of rugged charm and modern elegance."
},
{
name: "The Talisman",
url: "https://www.agnoulitahats.com/products/western-country-hat-talisman-desert-taupe-brown",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Rugged-Western-Country-Hat-for-Outdoor-Adventures-The-Talisman-Agnoulita-Hats-1.webp?v=1727384897",
price: 215,
subtitle: "Rugged Western Country Hat for Outdoor Adventures",
overview: "Adventure-ready, the Talisman hat is crafted for rugged outdoor use. Its wide brim offers excellent sun protection, while its sturdy design makes it a go-to choice for any outdoor activity."
}
],
"Heart,Short,Vintage": [
{
name: "The Skimmer",
url: "https://www.agnoulitahats.com/products/mens-straw-boater-hat-skimmer",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Vintage-Style-Mens-Straw-Boater-Hat-with-Custom-Options-The-Skimmer-Agnoulita-Hats-1_77c1123c-a4ce-41f7-afe8-7c9b52a9cd6e.webp?v=1726696928",
price: 175,
subtitle: "Vintage Style Men's Boater Hat",
overview: "The Skimmer boater hat brings a dash of vintage charm to your summer wardrobe. It's the perfect blend of classic style and modern comfort, ready to accompany you from garden parties to seaside strolls."
},
{
name: "The Antico",
url: "https://www.agnoulitahats.com/products/brown-classic-porkpie-hat-custom-fit",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-Classic-Porkpie-Fedora-Hat-in-Premium-Wool-Felt-The-Antico-Agnoulita-Hats-1.webp?v=1726780513",
price: 190,
subtitle: "Brown Classic Porkpie Fedora Hat",
overview: "The Antico is a brown classic porkpie fedora handcrafted from premium European wool felt. Custom-made for a perfect fit, this hat offers timeless elegance with modern flair for any occasion."
},
{
name: "The Soul",
url: "https://www.agnoulitahats.com/products/black-porkpie-hat-the-soul",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Classic-Black-Porkpie-Hat-in-Quality-Fur-Felt-The-Soul-Agnoulita-Hats-1_b6c02019-8a59-4bf9-b16b-bcf569b44b6b.webp?v=1726696201",
price: 215,
subtitle: "Classic Black Porkpie Hat",
overview: "The Soul is a classic black porkpie hat crafted from premium rabbit fur felt, featuring a telescope crown and upturned brim. Custom-made for a perfect fit, this elegant hat offers timeless sophistication and comfort."
}
],
"Heart,Short,Modern": [
{
name: "The Clubber",
url: "https://www.agnoulitahats.com/products/light-pink-fedora-hat-clubber",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Light-Pink-Fedora-with-Medium-Crown-in-Luxurious-Fur-Felt-The-Clubber-Agnoulita-Hats-1_1773d9af-238a-4daf-bd0b-c065fc46079c.webp?v=1726782676",
price: 215,
subtitle: "Light Pink Fedora with Medium Crown",
overview: "The Clubber is a light pink fedora made from premium rabbit fur felt, featuring a medium crown and upturned brim. Custom-made for a perfect fit, it combines style, elegance, and comfort, making it the perfect accessory for any occasion."
},
{
name: "The Equinox",
url: "https://www.agnoulitahats.com/products/fuchsia-fedora-hat-equinox",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Stylish-Fuchsia-Fedora-Hat-with-Custom-Fit-The-Equinox-Agnoulita-Hats-1_1c4ab564-3455-4490-b0f9-b5ab7aac574b.webp?v=1726782429",
price: 215,
subtitle: "Stylish Fuchsia Fedora Hat with Custom Fit",
overview: "The Equinox fuchsia fedora is a bold accessory for those who want to make a statement with their style. Its vibrant color, custom fit, and sophisticated details make it the perfect blend of modern fashion and classic elegance."
},
{
name: "The Echo",
url: "https://www.agnoulitahats.com/products/brown-trilby-hat-echo",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Taupe-Brown-Trilby-Hat-with-Stylish-Teardrop-Crown-The-Echo-Agnoulita-Hats-1_60f459ec-ae84-41ad-a0a0-77c0cfd819fa.webp?v=1726003175",
price: 215,
subtitle: "Taupe Brown Trilby Hat with Stylish Teardrop Crown",
overview: "The Echo trilby in taupe brown brings a touch of sophistication to any outfit. It's the ideal hat for those who appreciate classic style with a modern twist, ready to complement your look from workday to weekend."
}
],
"Heart,Average,Classic": [
{
name: "The Pathfinder",
url: "https://www.agnoulitahats.com/products/wide-brim-fedora-mens-style-pathfinder-brown",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-Wide-Brim-Fedora-in-Classic-Mens-Style-The-Pathfinder-Agnoulita-Hats-1_76052294-66c9-45a9-9008-d38e627e6555.webp?v=1726262460",
price: 215,
subtitle: "Brown Wide Brim Fedora in Classic Men's Style",
overview: "The Pathfinder is a brown wide brim fedora with a teardrop crown, handcrafted from premium rabbit fur felt. Custom-made for a perfect fit, this classic hat blends style and sun protection for every occasion."
},
{
name: "The Silkstone",
url: "https://www.agnoulitahats.com/products/1940s-fedora-hat-silkstone-brown",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-1940s-Fedora-Hat-Custom-Crafted-The-Silkstone-Agnoulita-Hats-1_55c804f0-0f2b-4532-8c54-8084d082a8a4.webp?v=1726262364",
price: 215,
subtitle: "Brown 1940s Fedora Hat - Custom Crafted",
overview: "The Silkstone, a brown 1940s fedora hat handcrafted from premium rabbit fur felt, combines vintage elegance with modern craftsmanship. Custom-made for a perfect fit, this hat offers timeless style and comfort."
},
{
name: "The Diplomat",
url: "https://www.agnoulitahats.com/products/mens-teardrop-fedora-diplomat-dark-grey",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Dark-Slate-Grey-Mens-Teardrop-Fedora-in-Smooth-Fur-Felt-The-Diplomat-Agnoulita-Hats-1_102c2463-8ff0-4515-b74e-5247fa777bc2.webp?v=1726607265",
price: 215,
subtitle: "Dark Slate Grey Men's Teardrop Fedora",
overview: "Handcrafted from premium rabbit fur felt, the Diplomat teardrop fedora offers a sophisticated silhouette and custom fit. This dark slate grey fedora blends timeless elegance with modern comfort."
}
],

"Heart,Average,Western": [
{
name: "The Gaucho",
url: "https://www.agnoulitahats.com/products/blue-flat-cowboy-hat-gaucho",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Dark-Blue-Flat-Cowboy-Hat-in-Durable-Fur-Felt-The-Gaucho-Agnoulita-Hats-1.webp?v=1726695210",
price: 215,
subtitle: "Dark Blue Flat Cowboy Hat in Durable Fur Felt",
overview: "The Gaucho is a dark blue flat cowboy hat crafted from durable rabbit fur felt, featuring a flat crown and steel-wired brim. Custom-made for a perfect fit, this hat offers a bold blend of Western charm and modern style."
},
{
name: "The Ulysses",
url: "https://www.agnoulitahats.com/products/mens-western-fedora-ulysses-chocolate-brown",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Chocolate-Brown-Mens-Western-Fedora-in-Rich-Fur-Felt-The-Ulysses-Agnoulita-Hats-1_bf9a7ae7-dc12-4cd0-942a-1c897c9fb33d.webp?v=1726696413",
price: 215,
subtitle: "Brown Men's Western Fedora in Rich Fur Felt",
overview: "The Ulysses is a chocolate brown men's western fedora crafted from premium rabbit fur felt, featuring a teardrop crown and ribbon-bound snap brim. Custom-made for a perfect fit, this hat offers a blend of rugged style and luxurious comfort."
},
{
name: "The Vanguard",
url: "https://www.agnoulitahats.com/products/brown-western-style-cowboy-hat-vanguard",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-Western-Style-Cowboy-Hat-in-High-Quality-Fur-Felt-The-Vanguard-Agnoulita-Hats-1.png?v=1726695763",
price: 215,
subtitle: "Brown Western Style Cowboy Hat in High-Quality Fur Felt",
overview: "The Vanguard, a brown western cowboy hat, is handcrafted from high-quality rabbit fur felt with a telescope crown and flat brim. Custom-made for a perfect fit, this hat blends classic western style with modern sophistication."
}
],
"Heart,Average,Vintage": [
{
name: "The Phaeton",
url: "https://www.agnoulitahats.com/products/1920s-mens-retro-homburg-phaeton-dark-navy-blue",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Dark-Navy-Blue-1920s-Mens-Retro-Homburg-Hat-The-Phaeton-Agnoulita-Hats-1_21540adf-bc11-4ceb-be60-2d1cd0dc8e2f.webp?v=1725829759",
price: 215,
subtitle: "Dark Navy Blue 1920's Men's Retro Homburg Hat",
overview: "The Phaeton is a dark navy blue 1920's retro homburg hat crafted from premium rabbit fur felt, featuring a center-dent crown and ribbon-bound rolled brim. Custom-made for a perfect fit, this hat combines vintage style with modern luxury."
},
{
name: "The Shadows",
url: "https://www.agnoulitahats.com/products/bogart-fedora-hat-shadows",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Grey-1940s-Bogart-Fedora-Hat-in-Smooth-Fur-Felt-The-Shadows-Agnoulita-Hats-1_61c3f72e-5246-4368-bd3f-8f55d727922b.webp?v=1726262224",
price: 215,
subtitle: "Grey 1940s Bogart Fedora Hat in Smooth Fur Felt",
overview: "The Shadows is a grey 1940s Bogart-style fedora crafted from premium rabbit fur felt, featuring a teardrop crown and raw-edge snap brim. Custom-made for a perfect fit, this fedora offers vintage charm and modern craftsmanship for any occasion."
},
{
name: "The Gin Joint",
url: "https://www.agnoulitahats.com/products/bogart-fedora-hat-film-noir-style-gin-joint",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Stylish-Bogart-Fedora-Hat-in-Grey-Fur-Felt-The-Gin-Joint-Agnoulita-Hats-1_4e8597fb-e546-4942-95e3-e40719b12a2d.webp?v=1726262096",
price: 215,
subtitle: "Stylish Bogart Fedora Hat in Grey Fur Felt",
overview: "The Gin Joint Bogart fedora brings the allure of classic cinema to your wardrobe. In sleek grey felt with a timeless silhouette, it's the perfect hat for those who appreciate vintage style with a modern twist."
}
],
"Heart,Average,Modern": [
{
name: "The Equinox",
url: "https://www.agnoulitahats.com/products/royal-blue-fedora-hat-equinox",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Stylish-Royal-Blue-Fedora-Hat-with-Teardrop-Crown-The-Equinox-Agnoulita-Hats-1.webp?v=1727298681",
price: 215,
subtitle: "Stylish Royal Blue Fedora Hat with Teardrop Crown",
overview: "The Equinox fedora in royal blue brings a pop of color to classic style. It's the perfect choice for those who love to make a bold statement while keeping things effortlessly cool and comfortable."
},
{
name: "The Taylor",
url: "https://www.agnoulitahats.com/products/rust-wide-brim-fedora-hat-taylor",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Rust-Wide-Brim-Fedora-Hat-in-Classy-Fur-Felt-The-Taylor-Agnoulita-Hats-1.webp?v=1726694320",
price: 215,
subtitle: "Rust Wide Brim Fedora Hat in Classy Fur Felt",
overview: "The Taylor is a rust wide-brim fedora handcrafted from luxurious rabbit fur felt. Featuring a center-dent crown and steel-wired brim, this custom-made hat offers a blend of elegance and practicality for any occasion."
},
{
name: "The Sovereign",
url: "https://www.agnoulitahats.com/products/brown-wide-brim-fedora-sovereign",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Taupe-Brown-Wide-Brim-Fedora-For-Men-The-Sovereign-Agnoulita-Hats-1.webp?v=1726348270",
price: 215,
subtitle: "Taupe Brown Wide Brim Fedora For Men",
overview: "The Sovereign is a taupe brown wide brim fedora crafted from premium rabbit fur felt, featuring a teardrop crown and underwelt snap brim. Custom-made for a perfect fit, this hat combines classic elegance with modern comfort, making it a standout accessory."
}
],
"Heart,Tall,Classic": [
{
name: "The Castor",
url: "https://www.agnoulitahats.com/products/mens-navy-blue-fedora-hat-castor",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Premium-Beaver-Fur-Mens-Navy-Blue-Fedora-Hat-The-Castor-Agnoulita-Hats-1.webp?v=1726002851",
price: 315,
subtitle: "Premium Beaver Fur Mens Navy Blue Fedora Hat",
overview: "Handcrafted from premium beaver fur, the Castor offers a bold, high crown design with a custom fit. This fedora blends sophistication with timeless elegance, perfect for any formal occasion."
},
{
name: "The Bostonian",
url: "https://www.agnoulitahats.com/products/the-bostonian",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Black-Wide-Brim-Homburg-Hat-in-Fur-Felt-The-Bostonian-Agnoulita-Hats-1.webp?v=1726002746",
price: 215,
subtitle: "Black Wide Brim Homburg Hat in Fur Felt",
overview: "The Bostonian, a black wide brim homburg hat crafted from premium fur felt, offers a bold, vintage-inspired design. Custom-made for a perfect fit, this hat blends timeless elegance with modern sophistication."
},
{
name: "The Acropol",
url: "https://www.agnoulitahats.com/products/dark-brown-fedora-hat-acropol",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Dark-Brown-Fedora-Hat-in-Classic-Mens-Style-The-Acropol-Agnoulita-Hats-1.webp?v=1726783016",
price: 315,
subtitle: "Dark Brown Fedora Hat in Classic Men's Style",
overview: "The Acropol is a dark brown fedora crafted from luxurious beaver fur felt, featuring a center-dent crown and customizable brim. Designed for a perfect fit, this fedora combines timeless elegance with modern sophistication for any occasion."
}
],
"Heart,Tall,Western": [
{
name: "The Crown",
url: "https://www.agnoulitahats.com/products/brown-wide-brim-rancher-fedora-crown",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-Wide-Brim-Rancher-Fedora-Hat-in-Durable-Fur-Felt-The-Crown-Agnoulita-Hats-1.png?v=1726435003",
price: 215,
subtitle: "Brown Wide Brim Rancher Fedora Hat in Durable Fur Felt",
overview: "The Crown, a brown wide brim rancher fedora, is handcrafted from durable rabbit fur felt with a center-dent crown. Custom-made for a perfect fit, this hat offers both rugged style and luxurious details."
},
{
name: "The Caribou",
url: "https://www.agnoulitahats.com/products/ound-crown-western-style-hat-caribou",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Round-Crown-Western-Style-Hat-in-Fur-Felt-The-Caribou-Agnoulita-Hats-1_96005cca-294b-4a75-ba8a-a9758b17c389.webp?v=1726866481",
price: 215,
subtitle: "Round Crown Western Style Hat in Fur Felt",
overview: "The Caribou brings the rugged charm of the West to your wardrobe with its bold round crown and wide brim. It's the go-to hat for those who want to make a statement, whether they're hitting the trail or the city streets."
},
{
name: "The Centaur",
url: "https://www.agnoulitahats.com/products/brown-outback-cowboy-hat-centaur",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-Outback-Cowboy-Hat-The-Centaur-Agnoulita-Hats-1_3bdf7727-0fb5-4b3d-9dc0-ffc52bd82ebf.png?v=1726435107",
price: 215,
subtitle: "Brown Outback Cowboy Hat",
overview: "The Centaur, a brown outback cowboy hat, is handcrafted from durable rabbit fur felt with a teardrop crown and flat brim for sun protection. Custom-made for comfort and style, it features a leather hat belt and timeless Western flair."
}
],
"Heart,Tall,Vintage": [
{
name: "The Signature",
url: "https://www.agnoulitahats.com/products/brown-homburg-hat-signature",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Elegant-Brown-Beaver-Fur-Felt-Homburg-Hat-for-Men-The-Signature-Agnoulita-Hats-1_c1491607-d833-463d-9c61-3816f6f98f56.webp?v=1725830090",
price: 315,
subtitle: "Elegant Brown Beaver Fur Felt Homburg Hat for Men",
overview: "The Signature is an elegant brown homburg hat for men, crafted from premium beaver fur felt with a single-crease crown and ribbon-bound rolled brim. Custom-made for a perfect fit, this hat offers classic sophistication for both formal and casual occasions."
},
{
name: "The Shadows",
url: "https://www.agnoulitahats.com/products/bogart-fedora-hat-shadows",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Grey-1940s-Bogart-Fedora-Hat-in-Smooth-Fur-Felt-The-Shadows-Agnoulita-Hats-1_61c3f72e-5246-4368-bd3f-8f55d727922b.webp?v=1726262224",
price: 215,
subtitle: "Grey 1940s Bogart Fedora Hat in Smooth Fur Felt",
overview: "The Shadows is a grey 1940s Bogart-style fedora crafted from premium rabbit fur felt, featuring a teardrop crown and raw-edge snap brim. Custom-made for a perfect fit, this fedora offers vintage charm and modern craftsmanship for any occasion."
},
{
name: "The Cerebelle",
url: "https://www.agnoulitahats.com/products/fur-felt-homburg-cerebelle-oxblood",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Handcrafted-Oxblood-Fur-Felt-Homburg-with-Custom-Fit-The-Cerebelle-Agnoulita-Hats-1_611ae925-f48f-4e91-a4dd-a04d56c23356.webp?v=1725916547",
price: 215,
subtitle: "Handcrafted Oxblood Fur Felt Homburg with Custom Fit",
overview: "Inspired by Poirot's timeless style, this customizable oxblood fur felt homburg hat blends classic elegance with expert craftsmanship. The Cerebelle offers a perfect fit and luxury comfort, making it ideal for any occasion."
}
],
"Heart,Tall,Modern": [
{
name: "The Joker",
url: "https://www.agnoulitahats.com/products/dark-purple-joker-fedora-hat",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Dark-Purple-Wide-Brim-Telescopic-Fedora-with-Custom-Options-The-Joker-Agnoulita-Hats-1_f384154b-f27b-47ae-b140-9da5c1d5771f.webp?v=1726696635",
price: 215,
subtitle: "Dark Purple Wide Brim Telescopic Fedora with Custom Options",
overview: "The Joker is a customizable dark purple wide-brim fedora inspired by Jack Nicholson's 1989 Batman character, featuring a flat crown and raw-edge flat brim. Made from luxurious rabbit fur felt, this iconic hat offers timeless style and personalization."
},
{
name: "The Rooster",
url: "https://www.agnoulitahats.com/products/wide-rolled-brim-fedora-hat-rooster",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Caribou-Grey-Wide-Rolled-Brim-Fedora-Hat-in-Fur-Felt-The-Rooster-Agnoulita-Hats-1_8bb3fcb3-17b2-46d1-998f-2c5a40263115.webp?v=1726695674",
price: 215,
subtitle: "Caribou Grey Wide Rolled Brim Fedora Hat in Fur Felt",
overview: "The Rooster is a caribou grey wide rolled brim fedora crafted from premium rabbit fur felt, featuring a bold 5 1/4 inch crown and a 3 1/2 inch rolled brim. Custom-made for a perfect fit, this hat combines modern flair with timeless sophistication."
},
{
name: "The Enigma",
url: "https://www.agnoulitahats.com/products/beige-wide-brim-fedora-hat-enigma",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Beige-Wide-Brim-Fedora-Hat-in-Premium-Fur-Felt-The-Enigma-Agnoulita-Hats-1_b7094b48-4c41-43da-90bd-3a39d1858b07.webp?v=1726696831",
price: 215,
subtitle: "Beige Wide Brim Fedora Hat in Premium Fur Felt",
overview: "The Enigma, a beige wide brim fedora made from premium rabbit fur felt, offers a bold and distinctive look with a teardrop crown. Custom-made for a perfect fit, this hat blends elegance with modern practicality."
}
],
"Diamond,Short,Classic": [
{
name: "The Cooper",
url: "https://www.agnoulitahats.com/products/black-low-crown-fedora-hat-cooper",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Low-Crown-Fedora-Hat-in-Black-Fur-Felt-The-Cooper-Agnoulita-Hats-1_3b92a6c0-3906-47dc-87dd-e49867bedb2e.webp?v=1726002542",
price: 215,
subtitle: "Low Crown Fedora Hat in Black",
overview: "The Cooper is a low crown fedora hat in black rabbit fur felt, offering a sleek and modern look with a minimalist ash grosgrain ribbon. Custom-made for comfort, this hat combines practicality and sophistication."
},
{
name: "The Diplomat",
url: "https://www.agnoulitahats.com/products/mens-teardrop-fedora-diplomat-dark-grey",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Dark-Slate-Grey-Mens-Teardrop-Fedora-in-Smooth-Fur-Felt-The-Diplomat-Agnoulita-Hats-1_102c2463-8ff0-4515-b74e-5247fa777bc2.webp?v=1726607265",
price: 215,
subtitle: "Dark Slate Grey Men's Teardrop Fedora",
overview: "Handcrafted from premium rabbit fur felt, the Diplomat teardrop fedora offers a sophisticated silhouette and custom fit. This dark slate grey fedora blends timeless elegance with modern comfort."
},
{
name: "The Phoenix",
url: "https://www.agnoulitahats.com/products/short-brim-fedora-phoenix-light-grey",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Classic-Short-Brim-Fedora-in-Light-Grey-Fur-Felt-The-Phoenix-Agnoulita-Hats-1_d44b0278-e604-4efa-8d38-de6423f59810.webp?v=1726866770",
price: 215,
subtitle: "Classic Short Brim Fedora in Light Grey",
overview: "The Phoenix is a light grey short brim fedora made from luxurious rabbit fur felt, featuring a 4 3/4\" crown and a 2 1/4\" snap brim. Custom-made for a perfect fit, this hat combines timeless style with modern elegance."
}
],
"Diamond,Short,Western": [
{
name: "The Bison",
url: "https://www.agnoulitahats.com/products/western-fedora-premium-fur-felt-bison",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-Short-Brim-Western-Fedora-in-Durable-Fur-Felt-The-Bison-Agnoulita-Hats-1_2c375126-e436-42a2-b94d-5f598dd2f564.png?v=1726434621",
price: 215,
subtitle: "Brown Short Brim Western Fedora",
overview: "The Bison, a brown short brim western fedora handcrafted from durable fur felt, combines classic elegance with Western style. Custom-made for a perfect fit, this hat offers comfort, quality, and individuality."
},
{
name: "The Voodoo",
url: "https://www.agnoulitahats.com/products/dark-grey-telescope-crown-country-hat-voodoo",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Dark-Grey-Telescope-Crown-Country-Style-Fur-Felt-Hat-The-Voodoo-Agnoulita-Hats-1.webp?v=1726695032",
price: 215,
subtitle: "Dark Grey Telescope Crown Country Style Hat",
overview: "The Voodoo is a dark grey telescope crown country hat crafted from premium rabbit fur felt, featuring a 3 3/4\" crown and a 2 5/8\" raw-edge flat brim. Custom-made for a perfect fit, this hat offers a blend of rugged charm and modern elegance."
},
{
name: "The Bolero",
url: "https://www.agnoulitahats.com/products/stylish-flat-top-felt-hat-burgundy-bolero",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Flat-Crown-Western-Cowboy-Hat-in-Black-Wool-Felt-The-Bolero-Agnoulita-Hats-1.webp?v=1726693735",
price: 190,
subtitle: "Flat Crown Western Cowboy Hat in Black Wool Felt",
overview: "The Bolero is a black flat crown cowboy hat made from high-quality wool felt, offering a timeless western look with customizable features. Perfect for both men and women, this handcrafted hat blends durability with bold style."
}
],
"Diamond,Short,Vintage": [
{
name: "The Soul",
url: "https://www.agnoulitahats.com/products/black-porkpie-hat-the-soul",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Classic-Black-Porkpie-Hat-in-Quality-Fur-Felt-The-Soul-Agnoulita-Hats-1_b6c02019-8a59-4bf9-b16b-bcf569b44b6b.webp?v=1726696201",
price: 215,
subtitle: "Classic Black Porkpie Hat",
overview: "The Soul is a classic black porkpie hat crafted from premium rabbit fur felt, featuring a telescope crown and upturned brim. Custom-made for a perfect fit, this elegant hat offers timeless sophistication and comfort."
},
{
name: "The Antico",
url: "https://www.agnoulitahats.com/products/casual-porkpie-hat-custom-handmade-black-wool",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-Classic-Porkpie-Fedora-Hat-in-Premium-Wool-Felt-The-Antico-Agnoulita-Hats-1.webp?v=1726780513",
price: 190,
subtitle: "Brown Classic Porkpie Fedora Hat",
overview: "The Antico is a brown classic porkpie fedora handcrafted from premium European wool felt. Custom-made for a perfect fit, this hat offers timeless elegance with modern flair for any occasion."
},
{
name: "The Coke",
url: "https://www.agnoulitahats.com/products/classic-black-bowler-hat-coke",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Classic-Bowler-Hat-for-Men-in-Black-Fur-Felt-The-Coke-Agnoulita-Hats-1.webp?v=1725829676",
price: 215,
subtitle: "Classic Bowler Hat for Men in Black Fur Felt",
overview: "The Coke is a classic black bowler hat crafted from premium fur felt, featuring an iconic hard shell and rounded crown. Custom-made for a perfect fit, this timeless piece reflects strength, character, and sophisticated style."
}
],
"Diamond,Short,Modern": [
{
name: "The Clubber",
url: "https://www.agnoulitahats.com/products/light-pink-fedora-hat-clubber",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Light-Pink-Fedora-with-Medium-Crown-in-Luxurious-Fur-Felt-The-Clubber-Agnoulita-Hats-1_1773d9af-238a-4daf-bd0b-c065fc46079c.webp?v=1726782676",
price: 215,
subtitle: "Light Pink Medium Crown Fedora",
overview: "The Clubber is a light pink fedora made from premium rabbit fur felt, featuring a medium crown and upturned brim. Custom-made for a perfect fit, it combines style, elegance, and comfort, making it the perfect accessory for any occasion."
},
{
name: "The Equinox",
url: "https://www.agnoulitahats.com/products/fuchsia-fedora-hat-equinox",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Stylish-Fuchsia-Fedora-Hat-with-Custom-Fit-The-Equinox-Agnoulita-Hats-1_1c4ab564-3455-4490-b0f9-b5ab7aac574b.webp?v=1726782429",
price: 215,
subtitle: "Stylish Fuchsia Fedora Hat with Custom Fit",
overview: "The Equinox fuchsia fedora is a bold accessory for those who want to make a statement with their style. Its vibrant color, custom fit, and sophisticated details make it the perfect blend of modern fashion and classic elegance."
},
{
name: "The Player",
url: "https://www.agnoulitahats.com/products/flat-top-wide-brim-fedora-player-grey",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Grey-Flat-Top-Wide-Brim-Fedora-in-Premium-Fur-Felt-The-Player-Agnoulita-Hats-1.webp?v=1726349364",
price: 215,
subtitle: "Grey Flat Top Wide Brim Fedora in Premium Fur Felt",
overview: "The Player is a flat top wide-brim fedora made from premium rabbit fur felt, featuring a distinctive design and available in various colors. Custom-made for a perfect fit, this hat combines bold style with luxurious comfort for any occasion."
}
],
"Diamond,Average,Classic": [
{
name: "The Pathfinder",
url: "https://www.agnoulitahats.com/products/wide-brim-fedora-mens-style-pathfinder-brown",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-Wide-Brim-Fedora-in-Classic-Mens-Style-The-Pathfinder-Agnoulita-Hats-1_76052294-66c9-45a9-9008-d38e627e6555.webp?v=1726262460",
price: 215,
subtitle: "Brown Wide Brim Fedora in Classic Men's Style",
overview: "The Pathfinder is a brown wide brim fedora with a teardrop crown, handcrafted from premium rabbit fur felt. Custom-made for a perfect fit, this classic hat blends style and sun protection for every occasion."
},
{
name: "The Silkstone",
url: "https://www.agnoulitahats.com/products/1940s-fedora-hat-silkstone-brown",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-1940s-Fedora-Hat-Custom-Crafted-The-Silkstone-Agnoulita-Hats-1_55c804f0-0f2b-4532-8c54-8084d082a8a4.webp?v=1726262364",
price: 215,
subtitle: "Brown 1940s Fedora Hat - Custom Crafted",
overview: "The Silkstone, a brown 1940s fedora hat handcrafted from premium rabbit fur felt, combines vintage elegance with modern craftsmanship. Custom-made for a perfect fit, this hat offers timeless style and comfort."
},
{
name: "The Diplomat",
url: "https://www.agnoulitahats.com/products/mens-teardrop-fedora-diplomat-dark-grey",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Dark-Slate-Grey-Mens-Teardrop-Fedora-in-Smooth-Fur-Felt-The-Diplomat-Agnoulita-Hats-1_102c2463-8ff0-4515-b74e-5247fa777bc2.webp?v=1726607265",
price: 215,
subtitle: "Dark Slate Grey Men's Teardrop Fedora",
overview: "Handcrafted from premium rabbit fur felt, the Diplomat teardrop fedora offers a sophisticated silhouette and custom fit. This dark slate grey fedora blends timeless elegance with modern comfort."
}
],
"Diamond,Average,Western": [
{
name: "The Gaucho",
url: "https://www.agnoulitahats.com/products/blue-flat-cowboy-hat-gaucho",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Dark-Blue-Flat-Cowboy-Hat-in-Durable-Fur-Felt-The-Gaucho-Agnoulita-Hats-1.webp?v=1726695210",
price: 215,
subtitle: "Dark Blue Flat Cowboy Hat in Durable Fur Felt",
overview: "The Gaucho is a dark blue flat cowboy hat crafted from durable rabbit fur felt, featuring a flat crown and steel-wired brim. Custom-made for a perfect fit, this hat offers a bold blend of Western charm and modern style."
},
{
name: "The Ulysses",
url: "https://www.agnoulitahats.com/products/mens-western-fedora-ulysses-chocolate-brown",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Chocolate-Brown-Mens-Western-Fedora-in-Rich-Fur-Felt-The-Ulysses-Agnoulita-Hats-1_bf9a7ae7-dc12-4cd0-942a-1c897c9fb33d.webp?v=1726696413",
price: 215,
subtitle: "Brown Men's Western Fedora in Rich Fur Felt",
overview: "The Ulysses is a chocolate brown men's western fedora crafted from premium rabbit fur felt, featuring a teardrop crown and ribbon-bound snap brim. Custom-made for a perfect fit, this hat offers a blend of rugged style and luxurious comfort."
},
{
name: "The Vanguard",
url: "https://www.agnoulitahats.com/products/brown-western-style-cowboy-hat-vanguard",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-Western-Style-Cowboy-Hat-in-High-Quality-Fur-Felt-The-Vanguard-Agnoulita-Hats-1.png?v=1726695763",
price: 215,
subtitle: "Brown Western Style Cowboy Hat in High-Quality Fur Felt",
overview: "The Vanguard, a brown western cowboy hat, is handcrafted from high-quality rabbit fur felt with a telescope crown and flat brim. Custom-made for a perfect fit, this hat blends classic western style with modern sophistication."
}
],
"Diamond,Average,Vintage": [
{
name: "The Phaeton",
url: "https://www.agnoulitahats.com/products/1920s-mens-retro-homburg-phaeton-dark-navy-blue",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Dark-Navy-Blue-1920s-Mens-Retro-Homburg-Hat-The-Phaeton-Agnoulita-Hats-1_21540adf-bc11-4ceb-be60-2d1cd0dc8e2f.webp?v=1725829759",
price: 215,
subtitle: "Dark Navy Blue 1920's Men's Retro Homburg Hat",
overview: "The Phaeton is a dark navy blue 1920's retro homburg hat crafted from premium rabbit fur felt, featuring a center-dent crown and ribbon-bound rolled brim. Custom-made for a perfect fit, this hat combines vintage style with modern luxury."
},
{
name: "The Shadows",
url: "https://www.agnoulitahats.com/products/bogart-fedora-hat-shadows",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Grey-1940s-Bogart-Fedora-Hat-in-Smooth-Fur-Felt-The-Shadows-Agnoulita-Hats-1_61c3f72e-5246-4368-bd3f-8f55d727922b.webp?v=1726262224",
price: 215,
subtitle: "Grey 1940s Bogart Fedora Hat in Smooth Fur Felt",
overview: "The Shadows is a grey 1940s Bogart-style fedora crafted from premium rabbit fur felt, featuring a teardrop crown and raw-edge snap brim. Custom-made for a perfect fit, this fedora offers vintage charm and modern craftsmanship for any occasion."
},
{
name: "The Gin Joint",
url: "https://www.agnoulitahats.com/products/bogart-fedora-hat-film-noir-style-gin-joint",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Stylish-Bogart-Fedora-Hat-in-Grey-Fur-Felt-The-Gin-Joint-Agnoulita-Hats-1_4e8597fb-e546-4942-95e3-e40719b12a2d.webp?v=1726262096",
subtitle: "Stylish Bogart Fedora Hat in Grey Fur Felt",
overview: "The Gin Joint Bogart fedora brings the allure of classic cinema to your wardrobe. In sleek grey felt with a timeless silhouette, it's the perfect hat for those who appreciate vintage style with a modern twist."
}
],
"Diamond,Average,Modern": [
{
name: "The Equinox",
url: "https://www.agnoulitahats.com/products/royal-blue-fedora-hat-equinox",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Stylish-Royal-Blue-Fedora-Hat-with-Teardrop-Crown-The-Equinox-Agnoulita-Hats-1.webp?v=1727298681",
price: 215,
subtitle: "Stylish Royal Blue Fedora Hat with Teardrop Crown",
overview: "The Equinox fedora in royal blue brings a pop of color to classic style. It's the perfect choice for those who love to make a bold statement while keeping things effortlessly cool and comfortable."
},
{
name: "The Taylor",
url: "https://www.agnoulitahats.com/products/burgundy-flat-brim-fedora-taylor",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Burgundy-Flat-Brim-Fedora-in-Elegant-Fur-Felt-The-Taylor-Agnoulita-Hats-1_d88c17b6-3bdb-498f-8bec-09ace06e9339.webp?v=1726694234",
price: 215,
subtitle: "Burgundy Flat Brim Fedora in Elegant Fur Felt",
overview: "The Taylor is a burgundy flat brim fedora handcrafted from luxurious rabbit fur felt. Featuring a center-dent crown and steel-wired brim, this custom-made hat offers a blend of elegance and practicality for any occasion."
},
{
name: "The Sovereign",
url: "https://www.agnoulitahats.com/products/forest-green-snap-brim-fedora-sovereign",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Forest-Green-Snap-Brim-Fedora-in-Stylish-Fur-Felt-The-Sovereign-Agnoulita-Hats-1.webp?v=1726348617",
price: 215,
subtitle: "Forest Green Snap Brim Fedora in Stylish Fur Felt",
overview: "The Sovereign is a forest green snap brim fedora crafted from premium rabbit fur felt, featuring a teardrop crown and underwelt snap brim. Custom-made for a perfect fit, this hat combines classic elegance with modern comfort, making it a standout accessory."
}
],
"Diamond,Tall,Classic": [
{
name: "The Castor",
url: "https://www.agnoulitahats.com/products/high-crown-fedora-hat-castor-black",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Black-High-Crown-Fedora-Hat-with-Custom-Sizes-The-Castor-Agnoulita-Hats-1.webp?v=1726002624",
price: 315,
subtitle: "Black High Crown Fedora Hat with Custom Sizes",
overview: "Handcrafted from black beaver fur felt, the Castor offers a bold, high crown design with a custom fit. This fedora blends sophistication with timeless elegance, perfect for any formal occasion."
},
{
name: "The Bostonian",
url: "https://www.agnoulitahats.com/products/the-bostonian",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Black-Wide-Brim-Homburg-Hat-in-Fur-Felt-The-Bostonian-Agnoulita-Hats-1.webp?v=1726002746",
price: 215,
subtitle: "Black Wide Brim Homburg Hat in Fur Felt",
overview: "The Bostonian, a black wide brim homburg hat crafted from premium fur felt, offers a bold, vintage-inspired design. Custom-made for a perfect fit, this hat blends timeless elegance with modern sophistication."
},
{
name: "The Acropol",
url: "https://www.agnoulitahats.com/products/dark-brown-fedora-hat-acropol",
image: "https://www.agnoulitahats.com/cdn/shop/files/Dark-Brown-Fedora-Hat-in-Classic-Mens-Style-The-Acropol-Agnoulita-Hats-1_ec1d1b53-8cb0-475c-8257-f39b36e785f5.webp?v=1726783016",
price: 315,
subtitle: "Dark Brown Fedora Hat in Classic Men's Style",
overview: "The Acropol is a dark brown fedora crafted from luxurious beaver fur felt, featuring a center-dent crown and customizable brim. Designed for a perfect fit, this fedora combines timeless elegance with modern sophistication for any occasion."
}
],
"Diamond,Tall,Western": [
{
name: "The Crown",
url: "https://www.agnoulitahats.com/products/brown-wide-brim-rancher-fedora-crown",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-Wide-Brim-Rancher-Fedora-Hat-in-Durable-Fur-Felt-The-Crown-Agnoulita-Hats-1.png?v=1726435003",
price: 215,
subtitle: "Brown Wide Brim Rancher Fedora Hat in Durable Fur Felt",
overview: "The Crown, a brown wide brim rancher fedora, is handcrafted from durable rabbit fur felt with a center-dent crown. Custom-made for a perfect fit, this hat offers both rugged style and luxurious details."
},
{
name: "The Caribou",
url: "https://www.agnoulitahats.com/products/ound-crown-western-style-hat-caribou",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Round-Crown-Western-Style-Hat-in-Fur-Felt-The-Caribou-Agnoulita-Hats-1_96005cca-294b-4a75-ba8a-a9758b17c389.webp?v=1726866481",
price: 215,
subtitle: "Round Crown Western Style Hat in Fur Felt",
overview: "The Caribou brings the rugged charm of the West to your wardrobe with its bold round crown and wide brim. It's the go-to hat for those who want to make a statement, whether they're hitting the trail or the city streets."
},
{
name: "The Centaur",
url: "https://www.agnoulitahats.com/products/black-western-outback-flat-brim-hat-centaur",
image: "https://www.agnoulitahats.com/cdn/shop/files/Black-Western-Outback-Flat-Brim-Hat-in-Durable-Fur-Felt-The-Centaur-Agnoulita-Hats-1_e258c773-3d9b-42d9-a1af-5e02fb37a2c2.png?v=1726434953",
price: 215,
subtitle: "Black Western Outback Flat Brim Hat in Durable Fur Felt",
overview: "The Centaur, a black western outback flat brim hat, is handcrafted from durable rabbit fur felt with a teardrop crown and flat brim for sun protection. Custom-made for comfort and style, it features a leather hat belt and timeless Western flair."
}
],
"Diamond,Tall,Vintage": [
{
name: "The Signature",
url: "https://www.agnoulitahats.com/products/brown-homburg-hat-signature",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Elegant-Brown-Beaver-Fur-Felt-Homburg-Hat-for-Men-The-Signature-Agnoulita-Hats-1_c1491607-d833-463d-9c61-3816f6f98f56.webp?v=1725830090",
price: 315,
subtitle: "Elegant Brown Beaver Fur Felt Homburg Hat for Men",
overview: "The Signature is an elegant brown homburg hat for men, crafted from premium beaver fur felt with a single-crease crown and ribbon-bound rolled brim. Custom-made for a perfect fit, this hat offers classic sophistication for both formal and casual occasions."
},
{
name: "The Shadows",
url: "https://www.agnoulitahats.com/products/1940s-fedora-vintage-elegance-shadows",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Exquisite-1940s-Inspired-Fedora-with-Vintage-Style-The-Shadows-Agnoulita-Hats-1.png?v=1726435243",
price: 215,
subtitle: "Exquisite 1940s Inspired Luxury Men's Fedora",
overview: "A true nod to the 1940s, the Shadows is an exquisite fedora with vintage flair. Its bold design, paired with premium materials, makes it perfect for those who appreciate fashion with history."
},
{
name: "The Cerebelle",
url: "https://www.agnoulitahats.com/products/grey-fur-felt-poirot-hat-cerebelle",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Customizable-Grey-Fur-Felt-Poirot-Homburg-Hat-The-Cerebelle-Agnoulita-Hats-1_376642e5-b143-4941-bfe1-a91280e9725f.webp?v=1725916454",
price: 215,
subtitle: "Customizable Grey Fur Felt Poirot Homburg Hat",
overview: "Inspired by Poirot's timeless style, this customizable grey fur felt homburg hat blends classic elegance with expert craftsmanship. The Cerebelle offers a perfect fit and luxury comfort, making it ideal for any occasion."
}
],
"Diamond,Tall,Modern": [
{
name: "The Ulysses",
url: "https://www.agnoulitahats.com/products/the-ulysses-wine-red-wide-brim-fedora",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Wine-Red-Wide-Brim-Fedora-Hat-with-Custom-Options-The-Ulysses-Agnoulita-Hats-1.png?v=1726781879",
price: 315,
subtitle: "Wine Red Wide Brim Fedora",
overview: "The Ulysses fedora in wine red brings a touch of boldness to your look, with its wide brim and customizable options, perfect for tall statures and square faces."
},
{
name: "The Oppenheimer",
url: "https://www.agnoulitahats.com/products/rustic-style-wide-brim-porkpie-hat-oppenheimer",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Handcrafted-Wide-Brim-Porkpie-Hat-with-Leather-Band-The-Oppenheimer-Agnoulita-Hats-1.webp?v=1727298586",
price: 315,
subtitle: "Wide Brim Porkpie Hat",
overview: "Inspired by cinematic classics, this wide brim porkpie hat combines a bold silhouette with premium beaver fur felt, ideal for tall statures and softening square faces."
},
{
name: "The Enigma",
url: "https://www.agnoulitahats.com/products/beige-wide-brim-fedora-hat-enigma",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Beige-Wide-Brim-Fedora-Hat-in-Premium-Fur-Felt-The-Enigma-Agnoulita-Hats-1_b7094b48-4c41-43da-90bd-3a39d1858b07.webp?v=1726696831",
price: 215,
subtitle: "Beige Wide Brim Fedora",
overview: "The Enigma, a beige wide brim fedora made from premium rabbit fur felt, offers a bold and distinctive look that complements tall statures and square faces."
}
],
"Oblong,Short,Classic": [
{
name: "The Cooper",
url: "https://www.agnoulitahats.com/products/low-crown-fedora-hat-cooper",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Low-Crown-Fedora-Hat-in-Black-Fur-Felt-The-Cooper-Agnoulita-Hats-1_3b92a6c0-3906-47dc-87dd-e49867bedb2e.webp?v=1726002542",
price: 215,
subtitle: "Low Crown Fedora Hat in Black",
overview: "The Cooper is a low crown fedora hat in black rabbit fur felt, offering a sleek and modern look with a minimalist ash grosgrain ribbon. Custom-made for comfort, this hat combines practicality and sophistication."
},
{
name: "The Phoenix",
url: "https://www.agnoulitahats.com/products/short-brim-fedora-phoenix-light-grey",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Classic-Short-Brim-Fedora-in-Light-Grey-Fur-Felt-The-Phoenix-Agnoulita-Hats-1_d44b0278-e604-4efa-8d38-de6423f59810.webp?v=1726866770",
price: 215,
subtitle: "Classic Short Brim Fedora in Light Grey",
overview: "The Phoenix is a light grey short brim fedora made from luxurious rabbit fur felt, featuring a 4 3/4\" crown and a 2 1/4\" snap brim. Custom-made for a perfect fit, this hat combines timeless style with modern elegance."
},
{
name: "The Diplomat",
url: "https://www.agnoulitahats.com/products/mens-teardrop-fedora-diplomat-dark-grey",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Dark-Slate-Grey-Mens-Teardrop-Fedora-in-Smooth-Fur-Felt-The-Diplomat-Agnoulita-Hats-1_102c2463-8ff0-4515-b74e-5247fa777bc2.webp?v=1726607265",
price: 215,
subtitle: "Dark Slate Grey Men's Teardrop Fedora",
overview: "Handcrafted from premium rabbit fur felt, the Diplomat teardrop fedora offers a sophisticated silhouette and custom fit. This dark slate grey fedora blends timeless elegance with modern comfort."
}
],
"Oblong,Short,Western": [
{
name: "The Bison",
url: "https://www.agnoulitahats.com/products/western-fedora-premium-fur-felt-bison",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-Short-Brim-Western-Fedora-in-Durable-Fur-Felt-The-Bison-Agnoulita-Hats-1_2c375126-e436-42a2-b94d-5f598dd2f564.png?v=1726434621",
price: 215,
subtitle: "Brown Short Brim Western Fedora",
overview: "The Bison, a brown short brim western fedora handcrafted from durable fur felt, combines classic elegance with Western style. Custom-made for a perfect fit, this hat offers comfort, quality, and individuality."
},
{
name: "The Voodoo",
url: "https://www.agnoulitahats.com/products/dark-grey-telescope-crown-country-hat-voodoo",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Dark-Grey-Telescope-Crown-Country-Style-Fur-Felt-Hat-The-Voodoo-Agnoulita-Hats-1.webp?v=1726695032",
price: 215,
subtitle: "Dark Grey Telescope Crown Country Style Hat",
overview: "The Voodoo is a dark grey telescope crown country hat crafted from premium rabbit fur felt, featuring a 3 3/4\" crown and a 2 5/8\" raw-edge flat brim. Custom-made for a perfect fit, this hat offers a blend of rugged charm and modern elegance."
},
{
name: "The Bolero",
url: "https://www.agnoulitahats.com/products/flat-crown-cowboy-hat-bolero-black",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Flat-Crown-Western-Cowboy-Hat-in-Black-Wool-Felt-The-Bolero-Agnoulita-Hats-1.webp?v=1726693735",
price: 190,
subtitle: "Flat Crown Western Cowboy Hat in Black Wool Felt",
overview: "The Bolero is a black flat crown cowboy hat made from high-quality wool felt, offering a timeless western look with customizable features. Perfect for both men and women, this handcrafted hat blends durability with bold style."
}
],
"Oblong,Short,Vintage": [
{
name: "The Soul",
url: "https://www.agnoulitahats.com/products/black-porkpie-hat-the-soul",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Classic-Black-Porkpie-Hat-in-Quality-Fur-Felt-The-Soul-Agnoulita-Hats-1_b6c02019-8a59-4bf9-b16b-bcf569b44b6b.webp?v=1726696201",
price: 215,
subtitle: "Classic Black Porkpie Hat",
overview: "The Soul is a classic black porkpie hat crafted from premium rabbit fur felt, featuring a telescope crown and upturned brim. Custom-made for a perfect fit, this elegant hat offers timeless sophistication and comfort."
},
{
name: "The Antico",
url: "https://www.agnoulitahats.com/products/brown-classic-porkpie-hat-custom-fit",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-Classic-Porkpie-Fedora-Hat-in-Premium-Wool-Felt-The-Antico-Agnoulita-Hats-1.webp?v=1726780513",
price: 190,
subtitle: "Brown Classic Porkpie Fedora Hat",
overview: "The Antico is a brown classic porkpie fedora handcrafted from premium European wool felt. Custom-made for a perfect fit, this hat offers timeless elegance with modern flair for any occasion."
},
{
name: "The Coke",
url: "https://www.agnoulitahats.com/products/classic-black-bowler-hat-coke",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Classic-Bowler-Hat-for-Men-in-Black-Fur-Felt-The-Coke-Agnoulita-Hats-1.webp?v=1725829676",
price: 215,
subtitle: "Classic Bowler Hat for Men in Black Fur Felt",
overview: "The Coke is a classic black bowler hat crafted from premium fur felt, featuring an iconic hard shell and rounded crown. Custom-made for a perfect fit, this timeless piece reflects strength, character, and sophisticated style."
}
],
"Oblong,Short,Modern": [
{
name: "The Clubber",
url: "https://www.agnoulitahats.com/products/light-pink-fedora-hat-clubber",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Light-Pink-Fedora-with-Medium-Crown-in-Luxurious-Fur-Felt-The-Clubber-Agnoulita-Hats-1_1773d9af-238a-4daf-bd0b-c065fc46079c.webp?v=1726782676",
price: 215,
subtitle: "Light Pink Medium Crown Fedora",
overview: "The Clubber is a light pink fedora made from premium rabbit fur felt, featuring a medium crown and upturned brim. Custom-made for a perfect fit, it combines style, elegance, and comfort, making it the perfect accessory for any occasion."
},
{
name: "The Equinox",
url: "https://www.agnoulitahats.com/products/fuchsia-fedora-hat-equinox",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Stylish-Fuchsia-Fedora-Hat-with-Custom-Fit-The-Equinox-Agnoulita-Hats-1_1c4ab564-3455-4490-b0f9-b5ab7aac574b.webp?v=1726782429",
price: 215,
subtitle: "Stylish Fuchsia Fedora Hat with Custom Fit",
overview: "The Equinox fuchsia fedora is a bold accessory for those who want to make a statement with their style. Its vibrant color, custom fit, and sophisticated details make it the perfect blend of modern fashion and classic elegance."
},
{
name: "The Echo",
url: "https://www.agnoulitahats.com/products/brown-trilby-hat-echo",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Taupe-Brown-Trilby-Hat-with-Stylish-Teardrop-Crown-The-Echo-Agnoulita-Hats-1_60f459ec-ae84-41ad-a0a0-77c0cfd819fa.webp?v=1726003175",
price: 215,
subtitle: "Taupe Brown Trilby Hat with Stylish Teardrop Crown",
overview: "The Echo trilby in taupe brown brings a touch of sophistication to any outfit. It's the ideal hat for those who appreciate classic style with a modern twist, ready to complement your look from workday to weekend."
}
],
"Oblong,Average,Classic": [
{
name: "The Pathfinder",
url: "https://www.agnoulitahats.com/products/wide-brim-fedora-mens-style-pathfinder-brown",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-Wide-Brim-Fedora-in-Classic-Mens-Style-The-Pathfinder-Agnoulita-Hats-1_76052294-66c9-45a9-9008-d38e627e6555.webp?v=1726262460",
price: 215,
subtitle: "Brown Wide Brim Fedora in Classic Men's Style",
overview: "The Pathfinder is a brown wide brim fedora with a teardrop crown, handcrafted from premium rabbit fur felt. Custom-made for a perfect fit, this classic hat blends style and sun protection for every occasion."
},
{
name: "The Silkstone",
url: "https://www.agnoulitahats.com/products/1940s-fedora-hat-silkstone-brown",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-1940s-Fedora-Hat-Custom-Crafted-The-Silkstone-Agnoulita-Hats-1_55c804f0-0f2b-4532-8c54-8084d082a8a4.webp?v=1726262364",
price: 215,
subtitle: "Brown 1940s Fedora Hat - Custom Crafted",
overview: "The Silkstone, a brown 1940s fedora hat handcrafted from premium rabbit fur felt, combines vintage elegance with modern craftsmanship. Custom-made for a perfect fit, this hat offers timeless style and comfort."
},
{
name: "The Diplomat",
url: "https://www.agnoulitahats.com/products/mens-teardrop-fedora-diplomat-dark-grey",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Dark-Slate-Grey-Mens-Teardrop-Fedora-in-Smooth-Fur-Felt-The-Diplomat-Agnoulita-Hats-1_102c2463-8ff0-4515-b74e-5247fa777bc2.webp?v=1726607265",
price: 215,
subtitle: "Dark Slate Grey Men's Teardrop Fedora",
overview: "Handcrafted from premium rabbit fur felt, the Diplomat teardrop fedora offers a sophisticated silhouette and custom fit. This dark slate grey fedora blends timeless elegance with modern comfort."
}
],
"Oblong,Average,Western": [
{
name: "The Gaucho",
url: "https://www.agnoulitahats.com/products/blue-flat-cowboy-hat-gaucho",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Dark-Blue-Flat-Cowboy-Hat-in-Durable-Fur-Felt-The-Gaucho-Agnoulita-Hats-1.webp?v=1726695210",
price: 215,
subtitle: "Dark Blue Flat Cowboy Hat in Durable Fur Felt",
overview: "The Gaucho is a dark blue flat cowboy hat crafted from durable rabbit fur felt, featuring a flat crown and steel-wired brim. Custom-made for a perfect fit, this hat offers a bold blend of Western charm and modern style."
},
{
name: "The Ulysses",
url: "https://www.agnoulitahats.com/products/mens-western-fedora-ulysses-chocolate-brown",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Chocolate-Brown-Mens-Western-Fedora-in-Rich-Fur-Felt-The-Ulysses-Agnoulita-Hats-1_bf9a7ae7-dc12-4cd0-942a-1c897c9fb33d.webp?v=1726696413",
price: 215,
subtitle: "Brown Men's Western Fedora in Rich Fur Felt",
overview: "The Ulysses is a chocolate brown men's western fedora crafted from premium rabbit fur felt, featuring a teardrop crown and ribbon-bound snap brim. Custom-made for a perfect fit, this hat offers a blend of rugged style and luxurious comfort."
},
{
name: "The Vanguard",
url: "https://www.agnoulitahats.com/products/brown-western-style-cowboy-hat-vanguard",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-Western-Style-Cowboy-Hat-in-High-Quality-Fur-Felt-The-Vanguard-Agnoulita-Hats-1.png?v=1726695763",
price: 215,
subtitle: "Brown Western Style Cowboy Hat in High-Quality Fur Felt",
overview: "The Vanguard, a brown western cowboy hat, is handcrafted from high-quality rabbit fur felt with a telescope crown and flat brim. Custom-made for a perfect fit, this hat blends classic western style with modern sophistication."
}
],
"Oblong,Average,Vintage": [
{
name: "The Phaeton",
url: "https://www.agnoulitahats.com/products/1920s-mens-retro-homburg-phaeton-dark-navy-blue",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Dark-Navy-Blue-1920s-Mens-Retro-Homburg-Hat-The-Phaeton-Agnoulita-Hats-1_21540adf-bc11-4ceb-be60-2d1cd0dc8e2f.webp?v=1725829759",
price: 215,
subtitle: "Dark Navy Blue 1920's Men's Retro Homburg Hat",
overview: "The Phaeton is a dark navy blue 1920's retro homburg hat crafted from premium rabbit fur felt, featuring a center-dent crown and ribbon-bound rolled brim. Custom-made for a perfect fit, this hat combines vintage style with modern luxury."
},
{
name: "The Shadows",
url: "https://www.agnoulitahats.com/products/bogart-fedora-hat-shadows",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Grey-1940s-Bogart-Fedora-Hat-in-Smooth-Fur-Felt-The-Shadows-Agnoulita-Hats-1_61c3f72e-5246-4368-bd3f-8f55d727922b.webp?v=1726262224",
price: 215,
subtitle: "Grey 1940s Bogart Fedora Hat in Smooth Fur Felt",
overview: "The Shadows is a grey 1940s Bogart-style fedora crafted from premium rabbit fur felt, featuring a teardrop crown and raw-edge snap brim. Custom-made for a perfect fit, this fedora offers vintage charm and modern craftsmanship for any occasion."
},
{
name: "The Gin Joint",
url: "https://www.agnoulitahats.com/products/bogart-fedora-hat-film-noir-style-gin-joint",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Stylish-Bogart-Fedora-Hat-in-Grey-Fur-Felt-The-Gin-Joint-Agnoulita-Hats-1_4e8597fb-e546-4942-95e3-e40719b12a2d.webp?v=1726262096",
price: 215,
subtitle: "Stylish Bogart Fedora Hat in Grey Fur Felt",
overview: "The Gin Joint Bogart fedora brings the allure of classic cinema to your wardrobe. In sleek grey felt with a timeless silhouette, it's the perfect hat for those who appreciate vintage style with a modern twist."
}
],
"Oblong,Average,Modern": [
{
name: "The Equinox",
url: "https://www.agnoulitahats.com/products/royal-blue-fedora-hat-equinox",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Stylish-Royal-Blue-Fedora-Hat-with-Teardrop-Crown-The-Equinox-Agnoulita-Hats-1.webp?v=1727298681",
price: 215,
subtitle: "Stylish Royal Blue Fedora Hat with Teardrop Crown",
overview: "The Equinox fedora in royal blue brings a pop of color to classic style. It's the perfect choice for those who love to make a bold statement while keeping things effortlessly cool and comfortable."
},
{
name: "The Taylor",
url: "https://www.agnoulitahats.com/products/burgundy-flat-brim-fedora-taylor",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Burgundy-Flat-Brim-Fedora-in-Elegant-Fur-Felt-The-Taylor-Agnoulita-Hats-1_d88c17b6-3bdb-498f-8bec-09ace06e9339.webp?v=1726694234",
price: 215,
subtitle: "Burgundy Flat Brim Fedora in Elegant Fur Felt",
overview: "The Taylor is a burgundy flat brim fedora handcrafted from luxurious rabbit fur felt. Featuring a center-dent crown and steel-wired brim, this custom-made hat offers a blend of elegance and practicality for any occasion."
},
{
name: "The Sovereign",
url: "https://www.agnoulitahats.com/products/forest-green-snap-brim-fedora-sovereign",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Forest-Green-Snap-Brim-Fedora-in-Stylish-Fur-Felt-The-Sovereign-Agnoulita-Hats-1.webp?v=1726348617",
price: 215,
subtitle: "Forest Green Snap Brim Fedora in Stylish Fur Felt",
overview: "The Sovereign is a forest green snap brim fedora crafted from premium rabbit fur felt, featuring a teardrop crown and underwelt snap brim. Custom-made for a perfect fit, this hat combines classic elegance with modern comfort, making it a standout accessory."
}
],
"Oblong,Tall,Classic": [
{
name: "The Castor",
url: "https://www.agnoulitahats.com/products/high-crown-fedora-hat-castor-black",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Black-High-Crown-Fedora-Hat-with-Custom-Sizes-The-Castor-Agnoulita-Hats-1.webp?v=1726002624",
price: 315,
subtitle: "Black High Crown Fedora Hat with Custom Sizes",
overview: "Handcrafted from black beaver fur felt, the Castor offers a bold, high crown design with a custom fit. This fedora blends sophistication with timeless elegance, perfect for any formal occasion."
},
{
name: "The Bostonian",
url: "https://www.agnoulitahats.com/products/the-bostonian",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Black-Wide-Brim-Homburg-Hat-in-Fur-Felt-The-Bostonian-Agnoulita-Hats-1.webp?v=1726002746",
price: 215,
subtitle: "Black Wide Brim Homburg Hat in Fur Felt",
overview: "The Bostonian, a black wide brim homburg hat crafted from premium fur felt, offers a bold, vintage-inspired design. Custom-made for a perfect fit, this hat blends timeless elegance with modern sophistication."
},
{
name: "The Acropol",
url: "https://www.agnoulitahats.com/products/dark-brown-fedora-hat-acropol",
image: "https://www.agnoulitahats.com/cdn/shop/files/Dark-Brown-Fedora-Hat-in-Classic-Mens-Style-The-Acropol-Agnoulita-Hats-1_ec1d1b53-8cb0-475c-8257-f39b36e785f5.webp",
price: 315,
subtitle: "Dark Brown Fedora Hat in Classic Men's Style",
overview: "The Acropol is a dark brown fedora crafted from luxurious beaver fur felt, featuring a center-dent crown and customizable brim. Designed for a perfect fit, this fedora combines timeless elegance with modern sophistication for any occasion."
}
],
"Oblong,Tall,Western": [
{
name: "The Crown",
url: "https://www.agnoulitahats.com/products/brown-wide-brim-rancher-fedora-crown",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Brown-Wide-Brim-Rancher-Fedora-Hat-in-Durable-Fur-Felt-The-Crown-Agnoulita-Hats-1.png?v=1726435003",
price: 215,
subtitle: "Brown Wide Brim Rancher Fedora Hat in Durable Fur Felt",
overview: "The Crown, a brown wide brim rancher fedora, is handcrafted from durable rabbit fur felt with a center-dent crown. Custom-made for a perfect fit, this hat offers both rugged style and luxurious details."
},
{
name: "The Caribou",
url: "https://www.agnoulitahats.com/products/ound-crown-western-style-hat-caribou",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Round-Crown-Western-Style-Hat-in-Fur-Felt-The-Caribou-Agnoulita-Hats-1_96005cca-294b-4a75-ba8a-a9758b17c389.webp?v=1726866481",
price: 215,
subtitle: "Round Crown Western Style Hat in Fur Felt",
overview: "The Caribou brings the rugged charm of the West to your wardrobe with its bold round crown and wide brim. It's the go-to hat for those who want to make a statement, whether they're hitting the trail or the city streets."
},
{
name: "The Centaur",
url: "https://www.agnoulitahats.com/products/black-western-outback-flat-brim-hat-centaur",
image: "https://www.agnoulitahats.com/cdn/shop/files/Black-Western-Outback-Flat-Brim-Hat-in-Durable-Fur-Felt-The-Centaur-Agnoulita-Hats-1_e258c773-3d9b-42d9-a1af-5e02fb37a2c2.png",
price: 215,
subtitle: "Black Western Outback Flat Brim Hat in Durable Fur Felt",
overview: "The Centaur, a black western outback flat brim hat, is handcrafted from durable rabbit fur felt with a teardrop crown and flat brim for sun protection. Custom-made for comfort and style, it features a leather hat belt and timeless Western flair."
}
],
"Oblong,Tall,Vintage": [
{
name: "The Signature",
url: "https://www.agnoulitahats.com/products/brown-homburg-hat-signature",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Elegant-Brown-Beaver-Fur-Felt-Homburg-Hat-for-Men-The-Signature-Agnoulita-Hats-1_c1491607-d833-463d-9c61-3816f6f98f56.webp?v=1725830090",
price: 315,
subtitle: "Elegant Brown Beaver Fur Felt Homburg Hat for Men",
overview: "The Signature is an elegant brown homburg hat for men, crafted from premium beaver fur felt with a single-crease crown and ribbon-bound rolled brim. Custom-made for a perfect fit, this hat offers classic sophistication for both formal and casual occasions."
},
{
name: "The Shadows",
url: "https://www.agnoulitahats.com/products/1940s-fedora-vintage-elegance-shadows",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Exquisite-1940s-Inspired-Fedora-with-Vintage-Style-The-Shadows-Agnoulita-Hats-1.png?v=1726435243",
price: 215,
subtitle: "Exquisite 1940s Inspired Luxury Men's Fedora",
overview: "A true nod to the 1940s, the Shadows is an exquisite fedora with vintage flair. Its bold design, paired with premium materials, makes it perfect for those who appreciate fashion with history."
},
{
name: "The Cerebelle",
url: "https://www.agnoulitahats.com/products/grey-fur-felt-poirot-hat-cerebelle",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Customizable-Grey-Fur-Felt-Poirot-Homburg-Hat-The-Cerebelle-Agnoulita-Hats-1_376642e5-b143-4941-bfe1-a91280e9725f.webp?v=1725916454",
price: 215,
subtitle: "Customizable Grey Fur Felt Poirot Homburg Hat",
overview: "Inspired by Poirot's timeless style, this customizable grey fur felt homburg hat blends classic elegance with expert craftsmanship. The Cerebelle offers a perfect fit and luxury comfort, making it ideal for any occasion."
}
],
"Oblong,Tall,Modern": [
{
name: "The Ulysses",
url: "https://www.agnoulitahats.com/products/the-ulysses-wine-red-wide-brim-fedora",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Wine-Red-Wide-Brim-Fedora-Hat-with-Custom-Options-The-Ulysses-Agnoulita-Hats-1.png?v=1726781879",
price: 315,
subtitle: "Wine Red Wide Brim Fedora",
overview: "The Ulysses fedora in wine red brings a touch of boldness to your look, with its wide brim and customizable options, perfect for tall statures and oblong faces."
},
{
name: "The Oppenheimer",
url: "https://www.agnoulitahats.com/products/rustic-style-wide-brim-porkpie-hat-oppenheimer",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Handcrafted-Wide-Brim-Porkpie-Hat-with-Leather-Band-The-Oppenheimer-Agnoulita-Hats-1.webp?v=1727298586",
price: 315,
subtitle: "Wide Brim Porkpie Hat",
overview: "Inspired by cinematic classics, this wide brim porkpie hat combines a bold silhouette with premium beaver fur felt, ideal for tall statures and complementing oblong faces."
},
{
name: "The Enigma",
url: "https://www.agnoulitahats.com/products/beige-wide-brim-fedora-hat-enigma",
image: "https://cdn.shopify.com/s/files/1/0549/3800/9848/files/Beige-Wide-Brim-Fedora-Hat-in-Premium-Fur-Felt-The-Enigma-Agnoulita-Hats-1_b7094b48-4c41-43da-90bd-3a39d1858b07.webp?v=1726696831",
price: 215,
subtitle: "Beige Wide Brim Fedora",
overview: "The Enigma, a beige wide brim fedora made from premium rabbit fur felt, offers a bold and distinctive look that complements tall statures and oblong faces."
}
]
  
  };

  const key = `${faceShape},${height},${style}`;
  const products = combinations[key] || [];

  let cardsHTML = `
    <div class="fedora-hat-gallery">
      <div class="gallery">
  `;

  products.forEach(product => {
    // Get localized URL for each product
    const localizedUrl = getLocalizedUrl(product.url);
    
    cardsHTML += `
      <div class="product">
        <div class="product-image">
          <img src="${product.image}" alt="${product.name}" style="width: 100%; height: auto; object-fit: contain;">
        </div>
        <div class="product-details">
          <h2>${product.name}</h2>
          <p>${product.subtitle}</p>
          <p class="price">${getTranslation('from')} ${product.price}</p>
          <p class="overview">${product.overview}</p>
          <a href="${localizedUrl}" class="btn">${getTranslation('viewDetails')}</a>
        </div>
      </div>
    `;
  });

  cardsHTML += `
      </div>
    </div>
  `;

  return cardsHTML;
}

function updateUITranslations() {
  // Update select options
  document.querySelectorAll('select option[value=""]').forEach(option => {
    const selectId = option.parentElement.id;
    if (selectId === 'agh-face-shape') option.textContent = getTranslation('selectFaceShape');
    if (selectId === 'agh-height') option.textContent = getTranslation('selectHeight');
    if (selectId === 'agh-style') option.textContent = getTranslation('selectStyle');
  });

  // Update height options
  const heightSelect = document.getElementById('agh-height');
  if (heightSelect) {
    Array.from(heightSelect.options).forEach(option => {
      if (option.value === 'Short') option.textContent = getTranslation('shortHeight');
      if (option.value === 'Average') option.textContent = getTranslation('averageHeight');
      if (option.value === 'Tall') option.textContent = getTranslation('tallHeight');
    });
  }

  // Update style options
  const styleSelect = document.getElementById('agh-style');
  if (styleSelect) {
    Array.from(styleSelect.options).forEach(option => {
      if (option.value === 'Classic') option.textContent = getTranslation('classicStyle');
      if (option.value === 'Western') option.textContent = getTranslation('westernStyle');
      if (option.value === 'Vintage') option.textContent = getTranslation('vintageStyle');
      if (option.value === 'Modern') option.textContent = getTranslation('modernStyle');
    });
  }

  // Update buttons
  const craftButton = document.querySelector('.agh-hat-guide-button');
  if (craftButton) craftButton.textContent = getTranslation('craftButton');
  
  const shopButton = document.querySelector('.agh-collection-button');
  if (shopButton) shopButton.textContent = getTranslation('shopCollection');
}

function aghGetHatGuidance() {
  const faceShape = document.getElementById('agh-face-shape').value;
  const height = document.getElementById('agh-height').value;
  const style = document.getElementById('agh-style').value;
  const resultDiv = document.getElementById('agh-result');

  if (!faceShape || !height || !style) {
    resultDiv.innerHTML = `<p>${getTranslation('selectAll')}</p>`;
    resultDiv.style.display = 'block';
    return;
  }

  // Guidance generation
  let guidance = `
    <h3>${getTranslation('personalizedGuide')}</h3>
    <div class="agh-result-separator"></div>
    <div class="agh-guidance-content">
      <p class="agh-result-content">
        ${getTranslation('basedOn')} <span class="agh-result-highlight">${faceShape.toLowerCase()} ${getTranslation('faceShape')}</span>,
        <span class="agh-result-highlight">${height.toLowerCase()} ${getTranslation('height')}</span>, ${getTranslation('andPreference')}
        <span class="agh-result-highlight">${style.toLowerCase()} ${getTranslation('styles')}</span>, ${getTranslation('guidance')}
      </p>
    </div>
  `;

  // Generate product cards
  const productCards = generateProductCards(faceShape, height, style);

  // Combine guidance and product cards
  resultDiv.innerHTML = guidance + productCards + `
    <h4 class="agh-guidance-heading">${getTranslation('readyToFind')}</h4>
    <div class="agh-guidance-paragraph">
      <span>${getTranslation('startingPoint')}</span>
      <span>${getTranslation('filterDescription')}</span>
      <span>${getTranslation('fromClassic')}</span>
    </div>
    <div class="agh-result-button-container">
      <a href="#collection" class="agh-result-button">${getTranslation('exploreCollection')}</a>
    </div>
  `;

  resultDiv.style.display = 'block';
  resultDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  updateUITranslations();
});

// Expose the function to the global scope
window.aghGetHatGuidance = aghGetHatGuidance;
